// src/codes.ts
var ErrorCodes = [
  "ERR_OLD_PASSWORD_NOT_STRING",
  "ERR_NEW_PASSWORD_NOT_STRING",
  "ERR_NEW_PASSWORD_MIN_LENGTH_8",
  "ERR_PASSWORD_NOT_EMPTY",
  "ERR_PASSWORD_NOT_STRING",
  "ERR_PASSWORD_MIN_LENGTH_8",
  "ERR_PASSWORD_MIN_LENGTH_12",
  "ERR_PASSWORD_MAX_LENGTH_255",
  "ERR_PASSWORD_NOT_VALID",
  "ERR_PASSWORD_COMPLEXITY",
  "ERR_PASSWORD_REPEATED_CHARS",
  "ERR_INVALID_TOKEN",
  "ERR_TOKEN_NOT_EMPTY",
  "ERR_TOKEN_NOT_STRING",
  "ERR_TURNSTILE_INVALID",
  "ERR_EMAIL_NOT_EMPTY",
  "ERR_EMAIL_NOT_VALID",
  "ERR_EMAIL_MAX_LENGTH_100",
  "ERR_EMAIL_MIN_LENGTH_3",
  "ERR_EMAIL_MAX_LENGTH_255",
  "ERR_NAME_NOT_STRING",
  "ERR_NAME_MIN_LENGTH_2",
  "ERR_NAME_MAX_LENGTH_255",
  "ERR_NAME_MIN_LENGTH_3",
  "ERR_NAME_MAX_LENGTH_100",
  "ERR_PAGE_MIN_1",
  "ERR_PAGE_NUMBER_INVALID",
  "ERR_PAGE_NUMBER_TOO_LOW",
  "ERR_ITEMS_PER_PAGE_MIN_1",
  "ERR_ITEMS_PER_PAGE_MAX_200",
  "ERR_ITEMS_PER_PAGE_INVALID",
  "ERR_ITEMS_PER_PAGE_TOO_LOW",
  "ERR_ITEMS_PER_PAGE_TOO_HIGH",
  "ERR_TYPE_NOT_VALID",
  "ERR_DESCRIPTION_NOT_STRING",
  "ERR_DESCRIPTION_MIN_LENGTH_10",
  "ERR_DESCRIPTION_MAX_LENGTH_1000",
  "ERR_DESCRIPTION_MAX_LENGTH_2000",
  "ERR_DESCRIPTION_LIST_NOT_ARRAY",
  "ERR_ADDRESS_NOT_OBJECT",
  "ERR_ADDRESS_CITY_NOT_STRING",
  "ERR_ADDRESS_CITY_MIN_LENGTH_2",
  "ERR_ADDRESS_CITY_MAX_LENGTH_50",
  "ERR_ADDRESS_POSTAL_CODE_NOT_STRING",
  "ERR_ADDRESS_POSTAL_CODE_NOT_VALID",
  "ERR_ADDRESS_COUNTRY_NOT_STRING",
  "ERR_ADDRESS_COUNTRY_MIN_LENGTH_2",
  "ERR_ADDRESS_COUNTRY_MAX_LENGTH_50",
  "ERR_ADDRESS_PROVINCE_NOT_STRING",
  "ERR_ADDRESS_PROVINCE_MAX_LENGTH_100",
  "ERR_ADDRESS_STREET_NOT_STRING",
  "ERR_ADDRESS_STREET_MAX_LENGTH_300",
  "ERR_PHONE_NOT_VALID",
  "ERR_ROLE_NOT_VALID",
  "ERR_ROLE_NOT_EMPTY",
  "ERR_IS_ACTIVE_NOT_BOOLEAN",
  "ERR_SEARCH_NOT_STRING",
  "ERR_SEARCH_QUERY_INVALID",
  "ERR_SEARCH_QUERY_TOO_LONG",
  "ERR_INVALID_UUID",
  "ERR_SERVICE_NOT_FOUND",
  "ERR_SERVICE_NOT_CREATED",
  "ERR_SERVICE_CREATE_FAILED",
  "ERR_SERVICE_DELETE_FAILED",
  "ERR_SERVICE_HAS_ORDERS",
  "ERR_SERVICE_GET_FAILED",
  "ERR_SERVICE_CATEGORY_NOT_FOUND",
  "ERR_SERVICE_CATEGORY_PARENT_NOT_FOUND",
  "ERR_SERVICE_CATEGORY_ALREADY_EXISTS",
  "ERR_SERVICE_CATEGORY_CANNOT_BE_PARENT_OF_ITSELF",
  "ERR_SERVICE_CATEGORY_HAS_CHILDREN",
  "ERR_SERVICE_CATEGORIES_GET_FAILED",
  "ERR_SERVICE_NOT_ASSIGNED_TO_CATEGORY",
  "ERR_SERVICE_CATEGORY_CANNOT_BE_DESCENDANT_OF_ITS_CHILD",
  "ERR_SERVICE_NOT_REMOVED_FROM_CATEGORY",
  "ERR_SERVICE_ID_INVALID",
  "ERR_SERVICE_NOT_AVAILABLE_AT_PLACE",
  "ERR_SERVICE_ALREADY_EXISTS",
  "ERR_SERVICE_COVER_NOT_FOUND",
  "ERR_SERVICE_COVER_FILE_ID_INVALID",
  "ERR_SERVICE_COVER_ALT_NOT_STRING",
  "ERR_SERVICE_COVER_ALT_MIN_LENGTH",
  "ERR_SERVICE_COVER_ALT_MAX_LENGTH",
  "ERR_SERVICE_COVER_CAPTION_NOT_STRING",
  "ERR_SERVICE_COVER_CAPTION_MIN_LENGTH",
  "ERR_SERVICE_COVER_CAPTION_MAX_LENGTH",
  "ERR_SERVICE_IDS_NOT_ARRAY",
  "ERR_SERVICE_ID_NOT_STRING",
  "ERR_INVALID_SERVICE_PLACES_DATA",
  "ERR_SERVICE_PLACE_RELATION_NOT_FOUND",
  "ERR_SERVICE_PLACES_NOT_CREATED",
  "ERR_SERVICE_PLACE_NOT_FOUND",
  "ERR_PLACE_NOT_FOUND",
  "ERR_PLACE_CATEGORY_NOT_FOUND",
  "ERR_PLACE_CATEGORY_PARENT_NOT_FOUND",
  "ERR_PLACE_CATEGORY_ALREADY_EXISTS",
  "ERR_PLACE_CATEGORY_CANNOT_BE_PARENT_OF_ITSELF",
  "ERR_PLACE_CATEGORY_HAS_CHILDREN",
  "ERR_PLACE_CATEGORIES_GET_FAILED",
  "ERR_PLACE_CATEGORY_CANNOT_BE_DESCENDANT_OF_ITS_CHILD",
  "ERR_PLACE_CATEGORY_TRANSLATION_REQUIRED",
  "ERR_PLACE_CATEGORY_BY_SLUG_GET_FAILED",
  "ERR_PLACE_NOT_ASSIGNED_TO_CATEGORY",
  "ERR_PLACE_NOT_REMOVED_FROM_CATEGORY",
  "ERR_PARENT_CATEGORY_IS_REQUIRED",
  "ERR_PLACE_ALREADY_EXISTS",
  "ERR_PLACE_IDS_NOT_ARRAY",
  "ERR_PLACE_ID_NOT_STRING",
  "ERR_PLACE_ID_INVALID",
  "ERR_DOCUMENT_TEMPLATE_NOT_FOUND",
  "ERR_DOCUMENT_TEMPLATE_IDS_NOT_ARRAY",
  "ERR_DOCUMENT_TEMPLATE_IDS_DUPLICATE",
  "ERR_CATEGORY_IDS_NOT_ARRAY",
  "ERR_CATEGORY_IDS_DUPLICATE",
  "ERR_IS_PANEL_NOT_BOOLEAN",
  "ERR_PLACE_IMAGE_ID_INVALID",
  "ERR_PLACE_IMAGE_SORT_ORDER_NOT_INT",
  "ERR_PLACE_IMAGE_SORT_ORDER_MIN",
  "ERR_PLACE_IMAGE_ALT_NOT_STRING",
  "ERR_PLACE_IMAGE_ALT_MIN_LENGTH",
  "ERR_PLACE_IMAGE_ALT_MAX_LENGTH",
  "ERR_PLACE_IMAGE_CAPTION_NOT_STRING",
  "ERR_PLACE_IMAGE_CAPTION_MIN_LENGTH",
  "ERR_PLACE_IMAGE_CAPTION_MAX_LENGTH",
  "ERR_PLACE_COVER_NOT_FOUND",
  "ERR_PLACE_COVER_FILE_ID_INVALID",
  "ERR_PLACE_COVER_ALT_NOT_STRING",
  "ERR_PLACE_COVER_ALT_MIN_LENGTH",
  "ERR_PLACE_COVER_ALT_MAX_LENGTH",
  "ERR_PLACE_COVER_CAPTION_NOT_STRING",
  "ERR_PLACE_COVER_CAPTION_MIN_LENGTH",
  "ERR_PLACE_COVER_CAPTION_MAX_LENGTH",
  "ERR_CREATE_PLACE_FAILED",
  "ERR_EDIT_PLACE_FAILED",
  "ERR_DELETE_PLACE_FAILED",
  "ERR_PLACE_HAS_ORDERS",
  "ERR_FETCH_PLACES_FAILED",
  "ERR_QUESTION_MIN_LENGTH_3",
  "ERR_QUESTION_MAX_LENGTH_255",
  "ERR_QUESTION_NOT_STRING",
  "ERR_ANSWER_MIN_LENGTH_10",
  "ERR_ANSWER_MAX_LENGTH_3000",
  "ERR_ANSWER_NOT_STRING",
  "ERR_USER_ID_INVALID",
  "ERR_USER_NOT_FOUND",
  "ERR_USER_NOT_ACTIVE",
  "ERR_USER_NOT_VERIFIED",
  "ERR_PASSWORD_CHANGE_REQUIRED",
  "ERR_TEMPORARY_PASSWORD_EXPIRED",
  "ERR_USER_ALREADY_EXISTS",
  "ERR_CREATE_USER_FAILED",
  "ERR_UPDATE_USER_FAILED",
  "ERR_DELETE_USER_FAILED",
  "ERR_USER_NOT_DELETED",
  "ERR_GET_USERS_FAILED",
  "ERR_GET_USER_FAILED",
  "ERR_USER_NOT_AUTHORIZED_TO_ACCESS_OFFER_GROUP",
  "ERR_USER_NOT_AUTHORIZED_TO_ACCESS_OFFER",
  "ERR_USER_FIRST_NAME_NOT_STRING",
  "ERR_USER_FIRST_NAME_MIN_LENGTH_2",
  "ERR_USER_FIRST_NAME_MAX_LENGTH_100",
  "ERR_USER_FIRST_NAME_NOT_EMPTY",
  "ERR_USER_LAST_NAME_NOT_STRING",
  "ERR_USER_LAST_NAME_MIN_LENGTH_2",
  "ERR_USER_LAST_NAME_MAX_LENGTH_100",
  "ERR_USER_LAST_NAME_NOT_EMPTY",
  "ERR_PREFERRED_DATES_INVALID_ARRAY",
  "ERR_PREFERRED_DATES_INVALID_LENGTH",
  "ERR_PREFERRED_DATES_INVALID_DATE_FORMAT",
  "ERR_PREFERRED_DATES_INVALID_FUTURE_OR_ORDER",
  "ERR_ORDER_MESSAGE_NOT_STRING",
  "ERR_ORDER_MESSAGE_MAX_LENGTH_2000",
  "ERR_ORDER_NOT_FOUND",
  "ERR_ORDER_CREATION_FAILED",
  "ERR_ORDER_UPDATE_FAILED",
  "ERR_ORDER_DELETION_FAILED",
  "ERR_ORDER_NOT_DELETED",
  "ERR_ORDER_STATUS_CHANGE_FAILED",
  "ERR_INVALID_ORDER_STATUS",
  "ERR_CANNOT_CREATE_ORDER_FOR_OTHER_USER",
  "ERR_ORDER_ID_NOT_EMPTY",
  "ERR_TRAVEL_FORM_NOT_FOUND",
  "ERR_TRAVEL_FORM_CREATE_FAILED",
  "ERR_TRAVEL_FORM_LIST_FAILED",
  "ERR_TRAVEL_FORM_SEND_FAILED",
  "ERR_TRAVEL_FORM_SUBMIT_FAILED",
  "ERR_TRAVEL_FORM_ALREADY_SENT",
  "ERR_TRAVEL_FORM_ALREADY_COMPLETED",
  "ERR_TRAVEL_FORM_NOT_SENT",
  "ERR_TRAVEL_FORM_DELETE_FAILED",
  "ERR_TRAVEL_FORM_CANNOT_DELETE_SENT",
  "ERR_FAQ_LIST_NOT_ARRAY",
  "ERR_LEVEL_NOT_INT",
  "ERR_LIMIT_NOT_INT",
  "ERR_LEVEL_TOO_LOW",
  "ERR_CATEGORY_NOT_FOUND",
  "ERR_INVALID_SLUG_FORMAT",
  "ERR_GET_CATEGORY_FAILED",
  "ERR_SLUG_NOT_STRING",
  "ERR_SLUG_MIN_LENGTH_2",
  "ERR_SLUG_MAX_LENGTH_100",
  "ERR_SLUG_MIN_LENGTH_3",
  "ERR_SLUG_MAX_LENGTH_255",
  "ERR_CONTENT_TITLE_NOT_STRING",
  "ERR_CONTENT_TITLE_MAX_LENGTH_255",
  "ERR_CONTENT_TITLE_MIN_LENGTH_3",
  "ERR_CONTENT_NAME_NOT_STRING",
  "ERR_CONTENT_NAME_MAX_LENGTH_255",
  "ERR_CONTENT_NAME_MIN_LENGTH_3",
  "ERR_CONTENT_DESCRIPTION_NOT_STRING",
  "ERR_CONTENT_DESCRIPTION_MIN_LENGTH_10",
  "ERR_CONTENT_DESCRIPTION_MAX_LENGTH_2000",
  "ERR_CONTENT_DESCRIPTION_MAX_LENGTH_3000",
  "ERR_CONTENT_LIST_NOT_ARRAY",
  "ERR_FAQ_NOT_ARRAY",
  "ERR_EXCERPT_NOT_STRING",
  "ERR_EXCERPT_MIN_LENGTH_3",
  "ERR_EXCERPT_MAX_LENGTH_255",
  "ERR_CHAT_MESSAGE_MAX_LENGTH_500",
  "ERR_ASSISTANT_SESSION_REQUIRED",
  "ERR_ASSISTANT_CHAT_ENTITY_IDS_INVALID",
  "ERR_ASSISTANT_TEMPORARILY_UNAVAILABLE",
  "ERR_ASSISTANT_QUOTA_EXHAUSTED",
  "ERR_ASSISTANT_RATE_LIMITED",
  "ERR_ASSISTANT_STREAM_IN_PROGRESS",
  "ERR_CONTACT_CONTENT_TOO_LONG",
  "ERR_FAILED_TO_SEND_EMAIL",
  "ERR_ORDER_EMAIL_NOT_CONFIGURED",
  "ERR_CONTACT_FORM_NOT_CONFIGURED",
  "ERR_NEWSLETTER_NOT_CONFIGURED",
  "ERR_NEWSLETTER_SUBSCRIPTION_FAILED",
  "ERR_FILE_NOT_FOUND",
  "ERR_FILE_CREATION_FAILED",
  "ERR_FILE_DELETION_FAILED",
  "ERR_INVALID_FILE_TYPE",
  "ERR_FILE_PATH_TRAVERSAL_DETECTED",
  "ERR_FILE_PATH_OUTSIDE_UPLOAD_DIR",
  "ERR_IPX_BAD_MODIFIER",
  "ERR_IPX_BAD_DIM",
  "ERR_IPX_BAD_QUALITY",
  "ERR_IPX_BAD_FORMAT",
  "ERR_IPX_BAD_FIT",
  "ERR_IPX_BAD_POSITION",
  "ERR_IPX_BAD_BACKGROUND",
  "ERR_IPX_MODIFIER_NOT_ALLOWED",
  "ERR_STATUS_NOT_VALID",
  "ERR_SERVICES_NOT_ARRAY",
  "ERR_PLACES_NOT_ARRAY",
  "ERR_IMAGES_NOT_ARRAY",
  "ERR_VIDEOS_NOT_ARRAY",
  "ERR_META_NOT_OBJECT",
  "ERR_INVALID_CREDENTIALS",
  "ERR_WEBSITE_NOT_VALID",
  "ERR_NOTES_NOT_VALID",
  "ERR_INVALID_DATE_FORMAT",
  "ERR_INVALID_ORDER_ID",
  "ERR_INVALID_DOCTOR_ID",
  "ERR_INVALID_TEMPLATE_KEY",
  "ERR_INVALID_TEMPLATE_VERSION",
  "ERR_CANNOT_CREATE_CONSULTATION_FOR_OTHER_USER",
  "ERR_CONSULTATION_CREATION_FAILED",
  "ERR_CONSULTATION_UPDATE_FAILED",
  "ERR_CONSULTATION_NOT_FOUND",
  "ERR_CANNOT_UPDATE_CONSULTATION_FOR_OTHER_USER",
  "ERR_CONSULTATIONS_NOT_FOUND",
  "ERR_CANNOT_DELETE_CONSULTATION",
  "ERR_CONSULTATION_DELETION_FAILED",
  "ERR_REQUIRES_CONSULTATION_NOT_BOOLEAN",
  "ERR_COUNTRY_NOT_ISO31661_ALPHA2",
  "ERR_COUNTRY_NOT_UPPERCASE",
  "ERR_COUNTRY_NOT_EMPTY",
  "ERR_COUNTRY_LENGTH_2",
  "ERR_LANGUAGE_NOT_STRING",
  "ERR_LANGUAGE_NOT_VALID",
  "ERR_LANGUAGE_NOT_LOWERCASE",
  "ERR_LANGUAGE_NOT_EMPTY",
  "ERR_LANGUAGE_LENGTH_2",
  "ERR_TIME_ZONE_NOT_STRING",
  "ERR_TIME_ZONE_NOT_VALID",
  "ERR_TIME_ZONE_NOT_EMPTY",
  "ERR_INVALID_DATE_RANGE",
  "ERR_INVALID_STATUS",
  "ERR_OFFER_GROUP_NOT_DELETABLE",
  "ERR_OFFER_GROUP_TITLE_NOT_EDITABLE",
  "ERR_PAYMENT_NOT_FOUND",
  "ERR_PAYMENT_STATUS_CHANGE_FAILED",
  "ERR_INVALID_PAYMENT_STATUS",
  "ERR_PAYMENT_NOT_UPDATED",
  "ERR_INVALID_PAYMENT_ID",
  "ERR_INVALID_PAYMENT_METHOD",
  "ERR_INVALID_AMOUNT",
  "ERR_INVALID_CURRENCY_CODE",
  "ERR_EXTERNAL_ID_MAX_LENGTH_255",
  "ERR_CREATE_PAYMENT_FAILED",
  "ERR_CANNOT_CREATE_PAYMENT_FOR_OTHER_USER",
  "ERR_CANNOT_ACCESS_PAYMENT",
  "ERR_PAYMENT_INITIALIZATION_FAILED",
  "ERR_WEBHOOK_HANDLING_FAILED",
  "ERR_PAYMENT_NOT_INITIALIZED",
  "ERR_PAYMENT_STATUS_CHECK_FAILED",
  "ERR_PAYMENT_PROVIDER_NOT_AVAILABLE",
  "ERR_PAYMENT_STRIPE_NOT_CONFIGURED",
  "ERR_INVALID_PAYMENT_PURPOSE",
  "ERR_INVALID_CONSULTATION_ID",
  "ERR_INVALID_OFFER_ID",
  "ERR_CONSULTATION_NOT_BELONG_TO_ORDER",
  "ERR_OFFER_NOT_BELONG_TO_ORDER",
  "ERR_PAYMENT_PURPOSE_MISMATCH",
  "ERR_CONSULTATION_ID_REQUIRED",
  "ERR_OFFER_ID_REQUIRED",
  "ERR_PAYMENT_AMOUNT_MISMATCH",
  "ERR_PAYMENT_AMOUNT_EXCEEDS_REMAINING",
  "ERR_PAYMENT_AMOUNT_REQUIRED",
  "ERR_PAYMENT_AMOUNT_NOT_POSITIVE",
  "ERR_PAYMENT_AMOUNT_EXCEEDS_ORDER_TOTAL",
  "ERR_PAYMENT_ALREADY_PAID",
  "ERR_DUPLICATE_PAYMENT_EXISTS",
  "ERR_ORDER_CHECKOUT_LINES_REQUIRED",
  "ERR_ORDER_CHECKOUT_NOT_FOUND",
  "ERR_ORDER_CHECKOUT_DUPLICATE_LINES",
  "ERR_ORDER_CHECKOUT_BILLABLE_IN_AWAITING_CHECKOUT",
  "ERR_ORDER_CHECKOUT_NOT_PAYABLE",
  "ERR_ORDER_CHECKOUT_PATIENT_ENSURE_FORBIDDEN",
  "ERR_ORDER_CHECKOUT_OFFER_PAYMENT_INIT_FORBIDDEN",
  "ERR_ORDER_CHECKOUT_NOT_CANCELLABLE",
  "ERR_ORDER_CHECKOUT_MANUAL_LINE_INVALID",
  "ERR_ORDER_CHECKOUT_NOT_RECORDABLE",
  "ERR_ORDER_CHECKOUT_TRANSFER_AMOUNT_INVALID",
  "ERR_ORDER_CHECKOUT_ADMIN_ONLY",
  "ERR_ORDER_CHECKOUT_TRANSFER_AMOUNT_EXCEEDS_REMAINING",
  "ERR_PAYMENT_ALREADY_COMPLETED",
  "ERR_REFUND_NOT_AVAILABLE",
  "ERR_REFUND_AMOUNT_NOT_POSITIVE",
  "ERR_REFUND_AMOUNT_EXCEEDS_AVAILABLE",
  "ERR_REFUND_FAILED",
  "ERR_INVALID_REDIRECT_URL_DOMAIN",
  "ERR_PAYMENT_REDIRECT_DOMAIN_NOT_CONFIGURED",
  "ERR_WEBHOOK_EVENT_ID_REQUIRED",
  "ERR_WEBHOOK_SIGNATURE_REQUIRED",
  "ERR_WEBHOOK_IP_NOT_ALLOWED",
  "ERR_PAYMENT_WEBHOOK_IP_WHITELIST_NOT_CONFIGURED",
  "ERR_INVALID_STATUS_TRANSITION",
  "ERR_EXTERNAL_ID_ALREADY_EXISTS",
  "ERR_OFFER_TITLE_NOT_STRING",
  "ERR_OFFER_TITLE_MAX_LENGTH_255",
  "ERR_OFFER_TITLE_MIN_LENGTH_3",
  "ERR_OFFER_PRICE_MAX_DECIMAL_PLACES",
  "ERR_OFFER_PRICE_MIN_VALUE",
  "ERR_OFFER_PRICE_MAX_VALUE",
  "ERR_OFFER_NOT_FOUND",
  "ERR_OFFER_CREATION_FAILED",
  "ERR_OFFER_UPDATE_FAILED",
  "ERR_OFFER_DELETION_FAILED",
  "ERR_OFFER_NOT_DELETED",
  "ERR_OFFER_GROUP_NOT_FOUND",
  "ERR_OFFER_GROUP_CREATION_FAILED",
  "ERR_OFFER_GROUP_UPDATE_FAILED",
  "ERR_OFFER_GROUP_DELETION_FAILED",
  "ERR_OFFER_GROUP_NOT_DELETED",
  "ERR_INVALID_RANGE_HEADER",
  "ERR_INVALID_URL",
  "ERR_SORT_ORDER_NOT_INTEGER",
  "ERR_SORT_ORDER_MIN_0",
  "ERR_SORT_NOT_VALID",
  "ERR_DOCTOR_NAME_NOT_STRING",
  "ERR_DOCTOR_NAME_MIN_LENGTH_3",
  "ERR_DOCTOR_NAME_MAX_LENGTH_255",
  "ERR_DOCTOR_DEGREE_NOT_STRING",
  "ERR_DOCTOR_DEGREE_MAX_LENGTH_255",
  "ERR_DOCTOR_SPECIALIZATION_NOT_STRING",
  "ERR_DOCTOR_SPECIALIZATION_MAX_LENGTH_255",
  "ERR_PRICE_INVALID",
  "ERR_TRANSLATIONS_NOT_ARRAY",
  "ERR_CLIENT_ALREADY_ASSIGNED",
  "ERR_CLIENT_NOT_PATIENT",
  "ERR_AGENT_RESEND_SET_PASSWORD_NOT_APPLICABLE",
  "ERR_AGENT_RESEND_SET_PASSWORD_TOO_SOON",
  "ERR_OFFER_GENERATED_DOCUMENT_NOT_FOUND",
  "ERR_OFFER_GENERATED_DOCUMENT_CREATION_FAILED",
  "ERR_OFFER_GENERATED_DOCUMENT_UPDATE_FAILED",
  "ERR_OFFER_DOCUMENT_GENERATION_FAILED",
  "ERR_OFFER_GENERATED_DOCUMENTS_NOT_READY",
  "ERR_OFFER_GENERATED_DOCUMENT_FAILED",
  "ERR_OFFER_DOCUMENTS_CONSENT_REQUIRED"
];
var ErrorCode = Object.fromEntries(ErrorCodes.map((code) => [code, code]));

// src/messages.ts
var messages = {
  [ErrorCode.ERR_OLD_PASSWORD_NOT_STRING]: {
    pl: "Stare has\u0142o musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Old password must be a string"
  },
  [ErrorCode.ERR_NEW_PASSWORD_NOT_STRING]: {
    pl: "Nowe has\u0142o musi by\u0107 ci\u0105giem znak\xF3w",
    en: "New password must be a string"
  },
  [ErrorCode.ERR_NEW_PASSWORD_MIN_LENGTH_8]: {
    pl: "Nowe has\u0142o musi mie\u0107 co najmniej 8 znak\xF3w",
    en: "New password must be at least 8 characters long"
  },
  [ErrorCode.ERR_PASSWORD_NOT_EMPTY]: {
    pl: "Has\u0142o nie mo\u017Ce by\u0107 puste",
    en: "Password cannot be empty"
  },
  [ErrorCode.ERR_PASSWORD_NOT_STRING]: {
    pl: "Has\u0142o musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Password must be a string"
  },
  [ErrorCode.ERR_PASSWORD_MIN_LENGTH_8]: {
    pl: "Has\u0142o musi mie\u0107 co najmniej 8 znak\xF3w",
    en: "Password must be at least 8 characters long"
  },
  [ErrorCode.ERR_PASSWORD_MIN_LENGTH_12]: {
    pl: "Has\u0142o musi mie\u0107 co najmniej 12 znak\xF3w",
    en: "Password must be at least 12 characters long"
  },
  [ErrorCode.ERR_PASSWORD_COMPLEXITY]: {
    pl: "Has\u0142o musi zawiera\u0107 wielk\u0105 liter\u0119, ma\u0142\u0105 liter\u0119, cyfr\u0119 i znak specjalny",
    en: "Password must contain uppercase, lowercase, digit and special character"
  },
  [ErrorCode.ERR_PASSWORD_REPEATED_CHARS]: {
    pl: "Has\u0142o nie mo\u017Ce zawiera\u0107 powtarzaj\u0105cych si\u0119 sekwencji znak\xF3w (np. aaaa, 1111)",
    en: "Password cannot contain repeated character sequences (e.g. aaaa, 1111)"
  },
  [ErrorCode.ERR_PASSWORD_MAX_LENGTH_255]: {
    pl: "Has\u0142o nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Password cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_PASSWORD_NOT_VALID]: {
    pl: "Has\u0142o nie jest prawid\u0142owe",
    en: "Password is not valid"
  },
  [ErrorCode.ERR_TOKEN_NOT_EMPTY]: {
    pl: "Token nie mo\u017Ce by\u0107 pusty",
    en: "Token cannot be empty"
  },
  [ErrorCode.ERR_TOKEN_NOT_STRING]: {
    pl: "Token musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Token must be a string"
  },
  [ErrorCode.ERR_INVALID_TOKEN]: {
    pl: "Token jest nieprawid\u0142owy lub wygas\u0142",
    en: "Token is invalid or expired"
  },
  [ErrorCode.ERR_TURNSTILE_INVALID]: {
    pl: "Weryfikacja nie powiod\u0142a si\u0119. Spr\xF3buj ponownie.",
    en: "Verification failed. Please try again."
  },
  [ErrorCode.ERR_EMAIL_NOT_EMPTY]: {
    pl: "Email nie mo\u017Ce by\u0107 pusty",
    en: "Email cannot be empty"
  },
  [ErrorCode.ERR_EMAIL_NOT_VALID]: {
    pl: "Email nie jest prawid\u0142owy",
    en: "Email is not valid"
  },
  [ErrorCode.ERR_EMAIL_MAX_LENGTH_100]: {
    pl: "Email nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "Email cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_EMAIL_MIN_LENGTH_3]: {
    pl: "Email musi mie\u0107 co najmniej 3 znaki",
    en: "Email must be at least 3 characters long"
  },
  [ErrorCode.ERR_EMAIL_MAX_LENGTH_255]: {
    pl: "Email nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Email cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_FAILED_TO_SEND_EMAIL]: {
    pl: "Nie uda\u0142o si\u0119 wys\u0142a\u0107 wiadomo\u015Bci",
    en: "Failed to send message"
  },
  [ErrorCode.ERR_ORDER_EMAIL_NOT_CONFIGURED]: {
    pl: "Email zam\xF3wienia nie jest skonfigurowany",
    en: "Order email is not configured"
  },
  [ErrorCode.ERR_NAME_NOT_STRING]: {
    pl: "Nazwa musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Name must be a string"
  },
  [ErrorCode.ERR_NAME_MIN_LENGTH_2]: {
    pl: "Nazwa musi mie\u0107 co najmniej 2 znaki",
    en: "Name must be at least 2 characters long"
  },
  [ErrorCode.ERR_NAME_MAX_LENGTH_255]: {
    pl: "Nazwa nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Name cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_NAME_MIN_LENGTH_3]: {
    pl: "Nazwa musi mie\u0107 co najmniej 3 znaki",
    en: "Name must be at least 3 characters long"
  },
  [ErrorCode.ERR_NAME_MAX_LENGTH_100]: {
    pl: "Nazwa nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "Name cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_PAGE_MIN_1]: {
    pl: "Strona musi by\u0107 wi\u0119ksza ni\u017C 0",
    en: "Page must be greater than 0"
  },
  [ErrorCode.ERR_PAGE_NUMBER_INVALID]: {
    pl: "Nieprawid\u0142owy numer strony",
    en: "Invalid page number"
  },
  [ErrorCode.ERR_PAGE_NUMBER_TOO_LOW]: {
    pl: "Numer strony musi by\u0107 wi\u0119kszy ni\u017C 0",
    en: "Page number must be greater than 0"
  },
  [ErrorCode.ERR_ITEMS_PER_PAGE_MIN_1]: {
    pl: "Liczba element\xF3w na stronie musi by\u0107 wi\u0119ksza ni\u017C 0",
    en: "Number of items per page must be greater than 0"
  },
  [ErrorCode.ERR_ITEMS_PER_PAGE_MAX_200]: {
    pl: "Liczba element\xF3w na stronie nie mo\u017Ce by\u0107 wi\u0119ksza ni\u017C 200",
    en: "Number of items per page cannot be greater than 200"
  },
  [ErrorCode.ERR_ITEMS_PER_PAGE_INVALID]: {
    pl: "Nieprawid\u0142owa liczba element\xF3w na stronie",
    en: "Invalid items per page"
  },
  [ErrorCode.ERR_ITEMS_PER_PAGE_TOO_LOW]: {
    pl: "Liczba element\xF3w na stronie musi by\u0107 wi\u0119ksza ni\u017C 0",
    en: "Items per page must be greater than 0"
  },
  [ErrorCode.ERR_ITEMS_PER_PAGE_TOO_HIGH]: {
    pl: "Liczba element\xF3w na stronie nie mo\u017Ce by\u0107 wi\u0119ksza ni\u017C 100",
    en: "Items per page cannot be greater than 100"
  },
  [ErrorCode.ERR_TYPE_NOT_VALID]: {
    pl: "Typ nie jest prawid\u0142owy",
    en: "Type is not valid"
  },
  [ErrorCode.ERR_STATUS_NOT_VALID]: {
    pl: "Status nie jest prawid\u0142owy",
    en: "Invalid status"
  },
  [ErrorCode.ERR_DESCRIPTION_NOT_STRING]: {
    pl: "Opis musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Description must be a string"
  },
  [ErrorCode.ERR_DESCRIPTION_MIN_LENGTH_10]: {
    pl: "Opis musi mie\u0107 co najmniej 10 znak\xF3w",
    en: "Description must be at least 10 characters long"
  },
  [ErrorCode.ERR_DESCRIPTION_MAX_LENGTH_1000]: {
    pl: "Opis nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 1000 znak\xF3w",
    en: "Description cannot be longer than 1000 characters"
  },
  [ErrorCode.ERR_DESCRIPTION_MAX_LENGTH_2000]: {
    pl: "Opis nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 2000 znak\xF3w",
    en: "Description cannot be longer than 2000 characters"
  },
  [ErrorCode.ERR_DESCRIPTION_LIST_NOT_ARRAY]: {
    pl: "Lista opis\xF3w musi by\u0107 tablic\u0105",
    en: "Description list must be an array"
  },
  [ErrorCode.ERR_REQUIRES_CONSULTATION_NOT_BOOLEAN]: {
    pl: "Wymaga konsultacji musi by\u0107 booleanem",
    en: "Requires consultation must be a boolean"
  },
  [ErrorCode.ERR_ADDRESS_CITY_NOT_STRING]: {
    pl: "Miasto musi by\u0107 ci\u0105giem znak\xF3w",
    en: "City must be a string"
  },
  [ErrorCode.ERR_ADDRESS_CITY_MIN_LENGTH_2]: {
    pl: "Miasto musi mie\u0107 co najmniej 2 znaki",
    en: "City must be at least 2 characters long"
  },
  [ErrorCode.ERR_ADDRESS_CITY_MAX_LENGTH_50]: {
    pl: "Miasto nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 50 znak\xF3w",
    en: "City cannot be longer than 50 characters"
  },
  [ErrorCode.ERR_ADDRESS_POSTAL_CODE_NOT_STRING]: {
    pl: "Kod pocztowy musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Postal code must be a string"
  },
  [ErrorCode.ERR_ADDRESS_POSTAL_CODE_NOT_VALID]: {
    pl: "Kod pocztowy nie jest prawid\u0142owy",
    en: "Postal code is not valid"
  },
  [ErrorCode.ERR_ADDRESS_COUNTRY_NOT_STRING]: {
    pl: "Kraj musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Country must be a string"
  },
  [ErrorCode.ERR_ADDRESS_COUNTRY_MIN_LENGTH_2]: {
    pl: "Kraj musi mie\u0107 co najmniej 2 znaki",
    en: "Country must be at least 2 characters long"
  },
  [ErrorCode.ERR_ADDRESS_COUNTRY_MAX_LENGTH_50]: {
    pl: "Kraj nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 50 znak\xF3w",
    en: "Country cannot be longer than 50 characters"
  },
  [ErrorCode.ERR_ADDRESS_NOT_OBJECT]: {
    pl: "Adres musi by\u0107 obiektem",
    en: "Address must be an object"
  },
  [ErrorCode.ERR_ADDRESS_PROVINCE_NOT_STRING]: {
    pl: "Wojew\xF3dztwo musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Province must be a string"
  },
  [ErrorCode.ERR_ADDRESS_PROVINCE_MAX_LENGTH_100]: {
    pl: "Wojew\xF3dztwo nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "Province cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_ADDRESS_STREET_NOT_STRING]: {
    pl: "Ulica musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Street must be a string"
  },
  [ErrorCode.ERR_ADDRESS_STREET_MAX_LENGTH_300]: {
    pl: "Ulica nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 300 znak\xF3w",
    en: "Street cannot be longer than 300 characters"
  },
  [ErrorCode.ERR_PHONE_NOT_VALID]: {
    pl: "Telefon nie jest prawid\u0142owy",
    en: "Phone is not valid"
  },
  [ErrorCode.ERR_ROLE_NOT_VALID]: {
    pl: "Rola nie jest prawid\u0142owa",
    en: "Role is not valid"
  },
  [ErrorCode.ERR_ROLE_NOT_EMPTY]: {
    pl: "Rola nie mo\u017Ce by\u0107 pusta",
    en: "Role cannot be empty"
  },
  [ErrorCode.ERR_IS_ACTIVE_NOT_BOOLEAN]: {
    pl: "Aktywny musi by\u0107 booleanem",
    en: "Active must be a boolean"
  },
  [ErrorCode.ERR_SEARCH_NOT_STRING]: {
    pl: "Wyszukiwanie musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Search must be a string"
  },
  [ErrorCode.ERR_SEARCH_QUERY_INVALID]: {
    pl: "Nieprawid\u0142owe zapytanie wyszukiwania",
    en: "Invalid search query"
  },
  [ErrorCode.ERR_SEARCH_QUERY_TOO_LONG]: {
    pl: "Zapytanie wyszukiwania nie mo\u017Ce by\u0107 d\u0142u\u017Csze ni\u017C 255 znak\xF3w",
    en: "Search query cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_INVALID_UUID]: {
    pl: "Nieprawid\u0142owy format UUID",
    en: "Invalid UUID format"
  },
  [ErrorCode.ERR_PRICE_INVALID]: {
    pl: "Cena jest nieprawid\u0142owa",
    en: "Price is invalid"
  },
  [ErrorCode.ERR_TRANSLATIONS_NOT_ARRAY]: {
    pl: "T\u0142umaczenia musi by\u0107 tablic\u0105",
    en: "Translations must be an array"
  },
  [ErrorCode.ERR_SERVICE_NOT_FOUND]: {
    pl: "Us\u0142uga nie zosta\u0142a znaleziona",
    en: "Service not found"
  },
  [ErrorCode.ERR_SERVICE_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID us\u0142ugi",
    en: "Invalid service ID format"
  },
  [ErrorCode.ERR_SERVICE_NOT_CREATED]: {
    pl: "Us\u0142uga nie zosta\u0142a utworzona",
    en: "Service not created"
  },
  [ErrorCode.ERR_SERVICE_CREATE_FAILED]: {
    pl: "Tworzenie us\u0142ugi nie powiod\u0142o si\u0119",
    en: "Service creation failed"
  },
  [ErrorCode.ERR_SERVICE_DELETE_FAILED]: {
    pl: "Usuni\u0119cie us\u0142ugi nie powiod\u0142o si\u0119",
    en: "Service deletion failed"
  },
  [ErrorCode.ERR_SERVICE_HAS_ORDERS]: {
    pl: "Nie mo\u017Cna usun\u0105\u0107 us\u0142ugi, poniewa\u017C jest powi\u0105zana z zam\xF3wieniami",
    en: "Cannot delete service because it is associated with orders"
  },
  [ErrorCode.ERR_SERVICE_GET_FAILED]: {
    pl: "Pobranie us\u0142ug nie powiod\u0142o si\u0119",
    en: "Getting services failed"
  },
  [ErrorCode.ERR_INVALID_SERVICE_PLACES_DATA]: {
    pl: "Nieprawid\u0142owe dane powi\u0105za\u0144 us\u0142ugi z plac\xF3wkami",
    en: "Invalid service places data"
  },
  [ErrorCode.ERR_SERVICE_PLACE_RELATION_NOT_FOUND]: {
    pl: "Powi\u0105zanie us\u0142ugi z plac\xF3wk\u0105 nie istnieje",
    en: "Service-place relation not found"
  },
  [ErrorCode.ERR_SERVICE_PLACES_NOT_CREATED]: {
    pl: "Nie uda\u0142o si\u0119 utworzy\u0107 powi\u0105za\u0144 us\u0142ugi z plac\xF3wkami",
    en: "Failed to create service place relations"
  },
  [ErrorCode.ERR_SERVICE_PLACE_NOT_FOUND]: {
    pl: "Us\u0142uga nie jest dost\u0119pna w tej plac\xF3wce",
    en: "Service place not found"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_NOT_FOUND]: {
    pl: "Kategoria us\u0142ugi nie zosta\u0142a znaleziona",
    en: "Service category not found"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_PARENT_NOT_FOUND]: {
    pl: "Kategoria nadrz\u0119dna nie zosta\u0142a znaleziona",
    en: "Parent service category not found"
  },
  [ErrorCode.ERR_PARENT_CATEGORY_IS_REQUIRED]: {
    pl: "Kategoria nadrz\u0119dna jest wymagana",
    en: "Parent category is required"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_ALREADY_EXISTS]: {
    pl: "Kategoria us\u0142ugi o tej nazwie ju\u017C istnieje",
    en: "Service category with this name already exists"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_CANNOT_BE_PARENT_OF_ITSELF]: {
    pl: "Kategoria nie mo\u017Ce by\u0107 nadrz\u0119dna wzgl\u0119dem samej siebie",
    en: "Service category cannot be parent of itself"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_HAS_CHILDREN]: {
    pl: "Kategoria posiada podkategorie i nie mo\u017Ce zosta\u0107 usuni\u0119ta",
    en: "Service category has children and cannot be deleted"
  },
  [ErrorCode.ERR_SERVICE_CATEGORIES_GET_FAILED]: {
    pl: "Pobranie kategorii us\u0142ug nie powiod\u0142o si\u0119",
    en: "Getting service categories failed"
  },
  [ErrorCode.ERR_SERVICE_NOT_ASSIGNED_TO_CATEGORY]: {
    pl: "Us\u0142uga nie jest przypisana do tej kategorii",
    en: "Service is not assigned to this category"
  },
  [ErrorCode.ERR_SERVICE_CATEGORY_CANNOT_BE_DESCENDANT_OF_ITS_CHILD]: {
    pl: "Kategoria nie mo\u017Ce by\u0107 potomkiem swojego dziecka",
    en: "Service category cannot be descendant of its child"
  },
  [ErrorCode.ERR_SERVICE_NOT_REMOVED_FROM_CATEGORY]: {
    pl: "Us\u0142uga nie zosta\u0142a usuni\u0119ta z kategorii",
    en: "Service not removed from category"
  },
  [ErrorCode.ERR_SERVICE_COVER_NOT_FOUND]: {
    pl: "Ok\u0142adka us\u0142ugi nie zosta\u0142a znaleziona",
    en: "Service cover not found"
  },
  [ErrorCode.ERR_SERVICE_COVER_FILE_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID pliku",
    en: "Invalid file ID format"
  },
  [ErrorCode.ERR_SERVICE_COVER_ALT_NOT_STRING]: {
    pl: "Alt musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Alt must be a string"
  },
  [ErrorCode.ERR_SERVICE_COVER_ALT_MIN_LENGTH]: {
    pl: "Alt musi mie\u0107 co najmniej 3 znaki",
    en: "Alt must be at least 3 characters long"
  },
  [ErrorCode.ERR_SERVICE_COVER_ALT_MAX_LENGTH]: {
    pl: "Alt nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Alt cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_SERVICE_COVER_CAPTION_NOT_STRING]: {
    pl: "Caption musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Caption must be a string"
  },
  [ErrorCode.ERR_SERVICE_COVER_CAPTION_MIN_LENGTH]: {
    pl: "Caption musi mie\u0107 co najmniej 3 znaki",
    en: "Caption must be at least 3 characters long"
  },
  [ErrorCode.ERR_SERVICE_COVER_CAPTION_MAX_LENGTH]: {
    pl: "Caption nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Caption cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_SERVICES_NOT_ARRAY]: {
    pl: "Us\u0142ugi musi by\u0107 tablic\u0105",
    en: "Services must be an array"
  },
  [ErrorCode.ERR_SERVICE_IDS_NOT_ARRAY]: {
    pl: "ID us\u0142ug musi by\u0107 tablic\u0105",
    en: "Service IDs must be an array"
  },
  [ErrorCode.ERR_SERVICE_ID_NOT_STRING]: {
    pl: "ID us\u0142ugi musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Service ID must be a string"
  },
  [ErrorCode.ERR_SERVICE_NOT_AVAILABLE_AT_PLACE]: {
    pl: "Us\u0142uga nie jest dost\u0119pna w tej plac\xF3wce",
    en: "Service is not available at this place"
  },
  [ErrorCode.ERR_SERVICE_ALREADY_EXISTS]: {
    pl: "Us\u0142uga z rakim slugiem ju\u017C istnieje",
    en: "Service with this slug already exists"
  },
  [ErrorCode.ERR_PLACES_NOT_ARRAY]: {
    pl: "Plac\xF3wki musz\u0105 by\u0107 tablic\u0105",
    en: "Places must be an array"
  },
  [ErrorCode.ERR_PLACE_NOT_FOUND]: {
    pl: "Plac\xF3wka medyczna nie zosta\u0142a znaleziona",
    en: "Medical place not found"
  },
  [ErrorCode.ERR_DOCUMENT_TEMPLATE_NOT_FOUND]: {
    pl: "Nie znaleziono jednego lub wi\u0119cej szablon\xF3w dokument\xF3w",
    en: "One or more document templates were not found"
  },
  [ErrorCode.ERR_DOCUMENT_TEMPLATE_IDS_NOT_ARRAY]: {
    pl: "documentTemplateIds musi by\u0107 tablic\u0105",
    en: "documentTemplateIds must be an array"
  },
  [ErrorCode.ERR_DOCUMENT_TEMPLATE_IDS_DUPLICATE]: {
    pl: "documentTemplateIds nie mo\u017Ce zawiera\u0107 duplikat\xF3w",
    en: "documentTemplateIds must not contain duplicates"
  },
  [ErrorCode.ERR_PLACE_ALREADY_EXISTS]: {
    pl: "Plac\xF3wka medyczna o tej nazwie i adresie ju\u017C istnieje",
    en: "Medical place with this name and address already exists"
  },
  [ErrorCode.ERR_CREATE_PLACE_FAILED]: {
    pl: "Tworzenie plac\xF3wki medycznej nie powiod\u0142o si\u0119",
    en: "Creating medical place failed"
  },
  [ErrorCode.ERR_EDIT_PLACE_FAILED]: {
    pl: "Edycja plac\xF3wki medycznej nie powiod\u0142a si\u0119",
    en: "Editing medical place failed"
  },
  [ErrorCode.ERR_DELETE_PLACE_FAILED]: {
    pl: "Usuni\u0119cie plac\xF3wki medycznej nie powiod\u0142o si\u0119",
    en: "Deleting medical place failed"
  },
  [ErrorCode.ERR_PLACE_HAS_ORDERS]: {
    pl: "Nie mo\u017Cna usun\u0105\u0107 plac\xF3wki, poniewa\u017C jest powi\u0105zana z zam\xF3wieniami",
    en: "Cannot delete place because it is associated with orders"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_NOT_FOUND]: {
    pl: "Kategoria plac\xF3wek nie zosta\u0142a znaleziona",
    en: "Place category not found"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_PARENT_NOT_FOUND]: {
    pl: "Kategoria nadrz\u0119dna plac\xF3wek nie zosta\u0142a znaleziona",
    en: "Parent place category not found"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_ALREADY_EXISTS]: {
    pl: "Kategoria plac\xF3wek o tej nazwie ju\u017C istnieje",
    en: "Place category with this name already exists"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_CANNOT_BE_PARENT_OF_ITSELF]: {
    pl: "Kategoria plac\xF3wek nie mo\u017Ce by\u0107 nadrz\u0119dna wzgl\u0119dem samej siebie",
    en: "Place category cannot be parent of itself"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_HAS_CHILDREN]: {
    pl: "Kategoria plac\xF3wek posiada podkategorie i nie mo\u017Ce zosta\u0107 usuni\u0119ta",
    en: "Place category has children and cannot be deleted"
  },
  [ErrorCode.ERR_PLACE_CATEGORIES_GET_FAILED]: {
    pl: "Pobranie kategorii plac\xF3wek nie powiod\u0142o si\u0119",
    en: "Getting place categories failed"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_CANNOT_BE_DESCENDANT_OF_ITS_CHILD]: {
    pl: "Kategoria plac\xF3wek nie mo\u017Ce by\u0107 potomkiem swojego dziecka",
    en: "Place category cannot be descendant of its child"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_TRANSLATION_REQUIRED]: {
    pl: "Kategoria plac\xF3wek musi mie\u0107 przynajmniej jedn\u0105 t\u0142umaczenie",
    en: "Place category must have at least one translation"
  },
  [ErrorCode.ERR_PLACE_CATEGORY_BY_SLUG_GET_FAILED]: {
    pl: "Pobranie kategorii plac\xF3wek nie powiod\u0142o si\u0119",
    en: "Getting place category by slug failed"
  },
  [ErrorCode.ERR_PLACE_NOT_ASSIGNED_TO_CATEGORY]: {
    pl: "Plac\xF3wka nie jest przypisana do tej kategorii",
    en: "Place is not assigned to this category"
  },
  [ErrorCode.ERR_PLACE_NOT_REMOVED_FROM_CATEGORY]: {
    pl: "Plac\xF3wka nie zosta\u0142a usuni\u0119ta z kategorii",
    en: "Place not removed from category"
  },
  [ErrorCode.ERR_FETCH_PLACES_FAILED]: {
    pl: "Pobranie listy plac\xF3wek medycznych nie powiod\u0142o si\u0119",
    en: "Fetching medical places list failed"
  },
  [ErrorCode.ERR_PLACE_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID plac\xF3wki",
    en: "Invalid place ID format"
  },
  [ErrorCode.ERR_PLACE_IMAGE_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID obrazu",
    en: "Invalid image ID format"
  },
  [ErrorCode.ERR_PLACE_IMAGE_SORT_ORDER_NOT_INT]: {
    pl: "Sort order musi by\u0107 liczb\u0105 ca\u0142kowit\u0105",
    en: "Sort order must be an integer"
  },
  [ErrorCode.ERR_PLACE_IMAGE_SORT_ORDER_MIN]: {
    pl: "Sort order musi by\u0107 wi\u0119kszy ni\u017C 0",
    en: "Sort order must be greater than 0"
  },
  [ErrorCode.ERR_PLACE_IMAGE_ALT_NOT_STRING]: {
    pl: "Alt musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Alt must be a string"
  },
  [ErrorCode.ERR_PLACE_IMAGE_ALT_MIN_LENGTH]: {
    pl: "Alt musi mie\u0107 co najmniej 3 znaki",
    en: "Alt must be at least 3 characters long"
  },
  [ErrorCode.ERR_PLACE_IMAGE_ALT_MAX_LENGTH]: {
    pl: "Alt nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Alt cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_PLACE_IMAGE_CAPTION_NOT_STRING]: {
    pl: "Caption musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Caption must be a string"
  },
  [ErrorCode.ERR_PLACE_IMAGE_CAPTION_MIN_LENGTH]: {
    pl: "Caption musi mie\u0107 co najmniej 3 znaki",
    en: "Caption must be at least 3 characters long"
  },
  [ErrorCode.ERR_PLACE_IMAGE_CAPTION_MAX_LENGTH]: {
    pl: "Caption nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Caption cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_PLACE_COVER_NOT_FOUND]: {
    pl: "Ok\u0142adka plac\xF3wki nie zosta\u0142a znaleziona",
    en: "Place cover not found"
  },
  [ErrorCode.ERR_PLACE_COVER_FILE_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID pliku",
    en: "Invalid file ID format"
  },
  [ErrorCode.ERR_PLACE_COVER_ALT_NOT_STRING]: {
    pl: "Alt musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Alt must be a string"
  },
  [ErrorCode.ERR_PLACE_COVER_ALT_MIN_LENGTH]: {
    pl: "Alt musi mie\u0107 co najmniej 3 znaki",
    en: "Alt must be at least 3 characters long"
  },
  [ErrorCode.ERR_PLACE_COVER_ALT_MAX_LENGTH]: {
    pl: "Alt nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Alt cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_PLACE_COVER_CAPTION_NOT_STRING]: {
    pl: "Caption musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Caption must be a string"
  },
  [ErrorCode.ERR_PLACE_COVER_CAPTION_MIN_LENGTH]: {
    pl: "Caption musi mie\u0107 co najmniej 3 znaki",
    en: "Caption must be at least 3 characters long"
  },
  [ErrorCode.ERR_PLACE_COVER_CAPTION_MAX_LENGTH]: {
    pl: "Caption nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Caption cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_PLACE_IDS_NOT_ARRAY]: {
    pl: "ID plac\xF3wek musi by\u0107 tablic\u0105",
    en: "Place IDs must be an array"
  },
  [ErrorCode.ERR_PLACE_ID_NOT_STRING]: {
    pl: "ID plac\xF3wki musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Place ID must be a string"
  },
  [ErrorCode.ERR_CATEGORY_IDS_NOT_ARRAY]: {
    pl: "ID kategorii musi by\u0107 tablic\u0105",
    en: "Category IDs must be an array"
  },
  [ErrorCode.ERR_CATEGORY_IDS_DUPLICATE]: {
    pl: "ID kategorii zawieraj\u0105 duplikaty",
    en: "Category IDs contain duplicates"
  },
  [ErrorCode.ERR_IS_PANEL_NOT_BOOLEAN]: {
    pl: "IsPanel musi by\u0107 boolean",
    en: "IsPanel must be a boolean"
  },
  [ErrorCode.ERR_QUESTION_MIN_LENGTH_3]: {
    pl: "Pytanie musi mie\u0107 co najmniej 3 znaki",
    en: "Question must be at least 3 characters long"
  },
  [ErrorCode.ERR_QUESTION_MAX_LENGTH_255]: {
    pl: "Pytanie nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Question cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_QUESTION_NOT_STRING]: {
    pl: "Pytanie musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Question must be a string"
  },
  [ErrorCode.ERR_ANSWER_MIN_LENGTH_10]: {
    pl: "Odpowied\u017A musi mie\u0107 co najmniej 10 znak\xF3w",
    en: "Answer must be at least 10 characters long"
  },
  [ErrorCode.ERR_ANSWER_MAX_LENGTH_3000]: {
    pl: "Odpowied\u017A nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 3000 znak\xF3w",
    en: "Answer cannot be longer than 3000 characters"
  },
  [ErrorCode.ERR_ANSWER_NOT_STRING]: {
    pl: "Odpowied\u017A musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Answer must be a string"
  },
  [ErrorCode.ERR_USER_ID_INVALID]: {
    pl: "Nieprawid\u0142owy format ID u\u017Cytkownika",
    en: "Invalid user ID format"
  },
  [ErrorCode.ERR_USER_NOT_FOUND]: {
    pl: "U\u017Cytkownik nie zosta\u0142 znaleziony",
    en: "User not found"
  },
  [ErrorCode.ERR_USER_NOT_ACTIVE]: {
    pl: "Konto u\u017Cytkownika jest nieaktywne",
    en: "User account is inactive"
  },
  [ErrorCode.ERR_USER_NOT_VERIFIED]: {
    pl: "Adres e-mail u\u017Cytkownika nie zosta\u0142 potwierdzony",
    en: "User email address has not been verified"
  },
  [ErrorCode.ERR_PASSWORD_CHANGE_REQUIRED]: {
    pl: "Musisz zmieni\u0107 has\u0142o, aby kontynuowa\u0107",
    en: "You must change your password to continue"
  },
  [ErrorCode.ERR_TEMPORARY_PASSWORD_EXPIRED]: {
    pl: "Has\u0142o tymczasowe wygas\u0142o. U\u017Cyj resetu has\u0142a, aby ustawi\u0107 nowe has\u0142o",
    en: "Temporary password has expired. Use password reset to set a new password"
  },
  [ErrorCode.ERR_USER_ALREADY_EXISTS]: {
    pl: "U\u017Cytkownik o podanym emailu ju\u017C istnieje",
    en: "User with this email already exists"
  },
  [ErrorCode.ERR_USER_NOT_DELETED]: {
    pl: "U\u017Cytkownik nie zosta\u0142 usuni\u0119ty",
    en: "User not deleted"
  },
  [ErrorCode.ERR_USER_FIRST_NAME_NOT_STRING]: {
    pl: "Imi\u0119 u\u017Cytkownika musi by\u0107 ci\u0105giem znak\xF3w",
    en: "User first name must be a string"
  },
  [ErrorCode.ERR_USER_FIRST_NAME_MIN_LENGTH_2]: {
    pl: "Imi\u0119 u\u017Cytkownika musi mie\u0107 co najmniej 2 znaki",
    en: "User first name must be at least 2 characters long"
  },
  [ErrorCode.ERR_USER_FIRST_NAME_MAX_LENGTH_100]: {
    pl: "Imi\u0119 u\u017Cytkownika nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "User first name cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_USER_LAST_NAME_NOT_STRING]: {
    pl: "Nazwa u\u017Cytkownika musi by\u0107 ci\u0105giem znak\xF3w",
    en: "User last name must be a string"
  },
  [ErrorCode.ERR_USER_LAST_NAME_MIN_LENGTH_2]: {
    pl: "Nazwa u\u017Cytkownika musi mie\u0107 co najmniej 2 znaki",
    en: "User last name must be at least 2 characters long"
  },
  [ErrorCode.ERR_USER_LAST_NAME_MAX_LENGTH_100]: {
    pl: "Nazwa u\u017Cytkownika nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "User last name cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_USER_FIRST_NAME_NOT_EMPTY]: {
    pl: "Imi\u0119 u\u017Cytkownika nie mo\u017Ce by\u0107 puste",
    en: "User first name cannot be empty"
  },
  [ErrorCode.ERR_USER_LAST_NAME_NOT_EMPTY]: {
    pl: "Nazwa u\u017Cytkownika nie mo\u017Ce by\u0107 pusta",
    en: "User last name cannot be empty"
  },
  [ErrorCode.ERR_CREATE_USER_FAILED]: {
    pl: "Tworzenie u\u017Cytkownika nie powiod\u0142o si\u0119",
    en: "Creating user failed"
  },
  [ErrorCode.ERR_UPDATE_USER_FAILED]: {
    pl: "Aktualizacja u\u017Cytkownika nie powiod\u0142a si\u0119",
    en: "Updating user failed"
  },
  [ErrorCode.ERR_DELETE_USER_FAILED]: {
    pl: "Usuni\u0119cie u\u017Cytkownika nie powiod\u0142o si\u0119",
    en: "Deleting user failed"
  },
  [ErrorCode.ERR_GET_USERS_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 uzyska\u0107 listy u\u017Cytkownik\xF3w",
    en: "Failed to get users list"
  },
  [ErrorCode.ERR_GET_USER_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 uzyska\u0107 u\u017Cytkownika",
    en: "Failed to get user"
  },
  [ErrorCode.ERR_PREFERRED_DATES_INVALID_ARRAY]: {
    pl: "Preferowane daty musz\u0105 by\u0107 tablic\u0105",
    en: "Preferred dates must be an array"
  },
  [ErrorCode.ERR_PREFERRED_DATES_INVALID_LENGTH]: {
    pl: "Preferowane daty musz\u0105 zawiera\u0107 dok\u0142adnie 2 daty",
    en: "Preferred dates must contain exactly 2 dates"
  },
  [ErrorCode.ERR_PREFERRED_DATES_INVALID_DATE_FORMAT]: {
    pl: "Nieprawid\u0142owy format daty",
    en: "Invalid date format"
  },
  [ErrorCode.ERR_PREFERRED_DATES_INVALID_FUTURE_OR_ORDER]: {
    pl: "Preferowane daty musz\u0105 by\u0107 w przysz\u0142o\u015Bci i w kolejno\u015Bci rosn\u0105cej",
    en: "Preferred dates must be in the future and in ascending order"
  },
  [ErrorCode.ERR_ORDER_MESSAGE_NOT_STRING]: {
    pl: "Wiadomo\u015B\u0107 do zam\xF3wienia musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Order message must be a string"
  },
  [ErrorCode.ERR_ORDER_MESSAGE_MAX_LENGTH_2000]: {
    pl: "Wiadomo\u015B\u0107 do zam\xF3wienia nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 2000 znak\xF3w",
    en: "Order message cannot be longer than 2000 characters"
  },
  [ErrorCode.ERR_ORDER_NOT_FOUND]: {
    pl: "Zam\xF3wienie nie zosta\u0142o znalezione",
    en: "Order not found"
  },
  [ErrorCode.ERR_ORDER_CREATION_FAILED]: {
    pl: "Tworzenie zam\xF3wienia nie powiod\u0142o si\u0119",
    en: "Order creation failed"
  },
  [ErrorCode.ERR_ORDER_UPDATE_FAILED]: {
    pl: "Aktualizacja zam\xF3wienia nie powiod\u0142a si\u0119",
    en: "Order update failed"
  },
  [ErrorCode.ERR_ORDER_DELETION_FAILED]: {
    pl: "Usuni\u0119cie zam\xF3wienia nie powiod\u0142o si\u0119",
    en: "Order deletion failed"
  },
  [ErrorCode.ERR_ORDER_NOT_DELETED]: {
    pl: "Zam\xF3wienie nie zosta\u0142o usuni\u0119te",
    en: "Order not deleted"
  },
  [ErrorCode.ERR_ORDER_STATUS_CHANGE_FAILED]: {
    pl: "Zmiana statusu zam\xF3wienia nie powiod\u0142a si\u0119",
    en: "Order status change failed"
  },
  [ErrorCode.ERR_ORDER_ID_NOT_EMPTY]: {
    pl: "ID zam\xF3wienia nie mo\u017Ce by\u0107 pusty",
    en: "Order ID cannot be empty"
  },
  [ErrorCode.ERR_CANNOT_CREATE_ORDER_FOR_OTHER_USER]: {
    pl: "Nie mo\u017Cna utworzy\u0107 zam\xF3wienia dla innego u\u017Cytkownika",
    en: "Cannot create order for another user"
  },
  [ErrorCode.ERR_TRAVEL_FORM_NOT_FOUND]: {
    pl: "Formularz rezerwacji i planu podr\xF3\u017Cy nie zosta\u0142 znaleziony",
    en: "Travel form not found"
  },
  [ErrorCode.ERR_TRAVEL_FORM_CREATE_FAILED]: {
    pl: "Utworzenie formularza rezerwacji i planu podr\xF3\u017Cy nie powiod\u0142o si\u0119",
    en: "Failed to create travel form"
  },
  [ErrorCode.ERR_TRAVEL_FORM_LIST_FAILED]: {
    pl: "Pobranie formularzy rezerwacji i planu podr\xF3\u017Cy nie powiod\u0142o si\u0119",
    en: "Failed to fetch travel forms"
  },
  [ErrorCode.ERR_TRAVEL_FORM_SEND_FAILED]: {
    pl: "Wys\u0142anie formularza rezerwacji i planu podr\xF3\u017Cy nie powiod\u0142o si\u0119",
    en: "Failed to send travel form"
  },
  [ErrorCode.ERR_TRAVEL_FORM_SUBMIT_FAILED]: {
    pl: "Zapisanie odpowiedzi formularza rezerwacji i planu podr\xF3\u017Cy nie powiod\u0142o si\u0119",
    en: "Failed to submit travel form"
  },
  [ErrorCode.ERR_TRAVEL_FORM_ALREADY_SENT]: {
    pl: "Formularz rezerwacji i planu podr\xF3\u017Cy zosta\u0142 ju\u017C wys\u0142any",
    en: "Travel form has already been sent"
  },
  [ErrorCode.ERR_TRAVEL_FORM_ALREADY_COMPLETED]: {
    pl: "Formularz rezerwacji i planu podr\xF3\u017Cy zosta\u0142 ju\u017C wype\u0142niony",
    en: "Travel form has already been completed"
  },
  [ErrorCode.ERR_TRAVEL_FORM_NOT_SENT]: {
    pl: "Formularz rezerwacji i planu podr\xF3\u017Cy nie zosta\u0142 jeszcze wys\u0142any",
    en: "Travel form has not been sent yet"
  },
  [ErrorCode.ERR_TRAVEL_FORM_DELETE_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 usun\u0105\u0107 formularza rezerwacji i planu podr\xF3\u017Cy",
    en: "Failed to delete travel form"
  },
  [ErrorCode.ERR_TRAVEL_FORM_CANNOT_DELETE_SENT]: {
    pl: "Nie mo\u017Cna usun\u0105\u0107 formularza, kt\xF3ry zosta\u0142 ju\u017C wys\u0142any",
    en: "Cannot delete travel form that has already been sent"
  },
  [ErrorCode.ERR_FAQ_LIST_NOT_ARRAY]: {
    pl: "Lista FAQ musi by\u0107 tablic\u0105",
    en: "FAQ list must be an array"
  },
  [ErrorCode.ERR_LEVEL_NOT_INT]: {
    pl: "Poziom musi by\u0107 liczb\u0105 ca\u0142kowit\u0105",
    en: "Level must be an integer"
  },
  [ErrorCode.ERR_LIMIT_NOT_INT]: {
    pl: "Limit musi by\u0107 liczb\u0105 ca\u0142kowit\u0105",
    en: "Limit must be an integer"
  },
  [ErrorCode.ERR_LEVEL_TOO_LOW]: {
    pl: "Poziom nie mo\u017Ce by\u0107 mniejszy ni\u017C -1",
    en: "Level cannot be less than -1"
  },
  [ErrorCode.ERR_CATEGORY_NOT_FOUND]: {
    pl: "Kategoria nie zosta\u0142a znaleziona",
    en: "Category not found"
  },
  [ErrorCode.ERR_INVALID_SLUG_FORMAT]: {
    pl: "Nieprawid\u0142owy format slug",
    en: "Invalid slug format"
  },
  [ErrorCode.ERR_GET_CATEGORY_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 uzyska\u0107 kategorii",
    en: "Failed to get category"
  },
  [ErrorCode.ERR_FILE_NOT_FOUND]: {
    pl: "Plik nie zosta\u0142 znaleziony",
    en: "File not found"
  },
  [ErrorCode.ERR_FILE_CREATION_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 utworzy\u0107 pliku",
    en: "Failed to create file"
  },
  [ErrorCode.ERR_FILE_DELETION_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 usun\u0105\u0107 pliku",
    en: "Failed to delete file"
  },
  [ErrorCode.ERR_INVALID_FILE_TYPE]: {
    pl: "Nieprawid\u0142owy typ pliku. Dozwolone typy: obrazy (JPEG, PNG, WebP, GIF), filmy (MP4, WebM, MOV, AVI) oraz dokumenty (PDF, DOC, DOCX)",
    en: "Invalid file type. Allowed types: images (JPEG, PNG, WebP, GIF), videos (MP4, WebM, MOV, AVI) and documents (PDF, DOC, DOCX)"
  },
  [ErrorCode.ERR_FILE_PATH_TRAVERSAL_DETECTED]: {
    pl: "Nieprawid\u0142owa \u015Bcie\u017Cka pliku - wykryto potencjalny atak path traversal",
    en: "Invalid file path - potential path traversal attack detected"
  },
  [ErrorCode.ERR_FILE_PATH_OUTSIDE_UPLOAD_DIR]: {
    pl: "Nieprawid\u0142owa \u015Bcie\u017Cka pliku - plik znajduje si\u0119 poza dozwolonym katalogiem",
    en: "Invalid file path - file is outside allowed upload directory"
  },
  [ErrorCode.ERR_IPX_BAD_MODIFIER]: {
    pl: "Nieprawid\u0142owy modyfikator",
    en: "Invalid modifier"
  },
  [ErrorCode.ERR_IPX_BAD_DIM]: {
    pl: "Nieprawid\u0142owy wymiar",
    en: "Invalid dimension"
  },
  [ErrorCode.ERR_IPX_BAD_QUALITY]: {
    pl: "Nieprawid\u0142owa jako\u015B\u0107",
    en: "Invalid quality"
  },
  [ErrorCode.ERR_IPX_BAD_FORMAT]: {
    pl: "Nieprawid\u0142owy format",
    en: "Invalid format"
  },
  [ErrorCode.ERR_IPX_BAD_FIT]: {
    pl: "Nieprawid\u0142owy fit",
    en: "Invalid fit"
  },
  [ErrorCode.ERR_IPX_BAD_POSITION]: {
    pl: "Nieprawid\u0142owa pozycja",
    en: "Invalid position"
  },
  [ErrorCode.ERR_IPX_BAD_BACKGROUND]: {
    pl: "Nieprawid\u0142owy kolor t\u0142a",
    en: "Invalid background color"
  },
  [ErrorCode.ERR_IPX_MODIFIER_NOT_ALLOWED]: {
    pl: "Modyfikator nie jest dozwolony",
    en: "Modifier not allowed"
  },
  [ErrorCode.ERR_IMAGES_NOT_ARRAY]: {
    pl: "Obrazy musi by\u0107 tablic\u0105",
    en: "Images must be an array"
  },
  [ErrorCode.ERR_VIDEOS_NOT_ARRAY]: {
    pl: "Wideo musi by\u0107 tablic\u0105",
    en: "Videos must be an array"
  },
  [ErrorCode.ERR_META_NOT_OBJECT]: {
    pl: "Meta musi by\u0107 obiektem",
    en: "Meta must be an object"
  },
  [ErrorCode.ERR_CHAT_MESSAGE_MAX_LENGTH_500]: {
    pl: "Wiadomo\u015B\u0107 do asystenta nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 500 znak\xF3w",
    en: "Assistant message cannot be longer than 500 characters"
  },
  [ErrorCode.ERR_ASSISTANT_SESSION_REQUIRED]: {
    pl: "Wymagana jest aktywna sesja przegl\u0105darki, aby korzysta\u0107 z czatu asystenta.",
    en: "An active browser session is required to use the assistant chat."
  },
  [ErrorCode.ERR_ASSISTANT_CHAT_ENTITY_IDS_INVALID]: {
    pl: "Nieprawid\u0142owe identyfikatory us\u0142ug lub miejsc (oczekiwane UUID, maksymalna liczba na list\u0119).",
    en: "Invalid service or place IDs (expected UUIDs, max count per list)."
  },
  [ErrorCode.ERR_ASSISTANT_TEMPORARILY_UNAVAILABLE]: {
    pl: "Asystent AI jest chwilowo niedost\u0119pny. Spr\xF3buj ponownie za chwil\u0119.",
    en: "The AI assistant is temporarily unavailable. Please try again shortly."
  },
  [ErrorCode.ERR_ASSISTANT_QUOTA_EXHAUSTED]: {
    pl: "Asystent AI jest chwilowo niedost\u0119pny z powodu limitu us\u0142ug. Spr\xF3buj ponownie p\xF3\u017Aniej lub skontaktuj si\u0119 z nami.",
    en: "The AI assistant is temporarily unavailable due to a service limit. Please try again later or contact us."
  },
  [ErrorCode.ERR_ASSISTANT_RATE_LIMITED]: {
    pl: "Zbyt wiele zapyta\u0144 do asystenta. Odczekaj chwil\u0119 i spr\xF3buj ponownie.",
    en: "Too many assistant requests. Please wait a moment and try again."
  },
  [ErrorCode.ERR_ASSISTANT_STREAM_IN_PROGRESS]: {
    pl: "Asystent ju\u017C przygotowuje odpowied\u017A. Poczekaj na jej zako\u0144czenie i spr\xF3buj ponownie.",
    en: "The assistant is already preparing a reply. Please wait for it to finish and try again."
  },
  [ErrorCode.ERR_CONTACT_CONTENT_TOO_LONG]: {
    pl: "Tre\u015B\u0107 nie mo\u017Ce by\u0107 d\u0142u\u017Csza ni\u017C 2000 znak\xF3w",
    en: "Content cannot be longer than 2000 characters"
  },
  [ErrorCode.ERR_CONTACT_FORM_NOT_CONFIGURED]: {
    pl: "Formularz kontaktowy nie jest skonfigurowany",
    en: "Contact form is not configured"
  },
  [ErrorCode.ERR_NEWSLETTER_NOT_CONFIGURED]: {
    pl: "Formularz newslettera nie jest skonfigurowany",
    en: "Newsletter form is not configured"
  },
  [ErrorCode.ERR_NEWSLETTER_SUBSCRIPTION_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 zapisa\u0107 do newslettera. Spr\xF3buj ponownie p\xF3\u017Aniej.",
    en: "Failed to subscribe to newsletter. Please try again later."
  },
  [ErrorCode.ERR_INVALID_CREDENTIALS]: {
    pl: "Nieprawid\u0142owe dane logowania",
    en: "Invalid login credentials"
  },
  [ErrorCode.ERR_LANGUAGE_NOT_STRING]: {
    pl: "J\u0119zyk musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Language must be a string"
  },
  [ErrorCode.ERR_SLUG_NOT_STRING]: {
    pl: "Slug musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Slug must be a string"
  },
  [ErrorCode.ERR_SLUG_MIN_LENGTH_2]: {
    pl: "Slug musi mie\u0107 co najmniej 2 znaki",
    en: "Slug must be at least 2 characters long"
  },
  [ErrorCode.ERR_SLUG_MAX_LENGTH_100]: {
    pl: "Slug nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 100 znak\xF3w",
    en: "Slug cannot be longer than 100 characters"
  },
  [ErrorCode.ERR_SLUG_MIN_LENGTH_3]: {
    pl: "Slug musi mie\u0107 co najmniej 3 znaki",
    en: "Slug must be at least 3 characters long"
  },
  [ErrorCode.ERR_SLUG_MAX_LENGTH_255]: {
    pl: "Slug nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Slug cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_FAQ_NOT_ARRAY]: {
    pl: "FAQ musi by\u0107 tablic\u0105",
    en: "FAQ must be an array"
  },
  [ErrorCode.ERR_EXCERPT_NOT_STRING]: {
    pl: "Zajawka musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Excerpt must be a string"
  },
  [ErrorCode.ERR_EXCERPT_MIN_LENGTH_3]: {
    pl: "Zajawka musi mie\u0107 co najmniej 3 znaki",
    en: "Excerpt must be at least 3 characters long"
  },
  [ErrorCode.ERR_EXCERPT_MAX_LENGTH_255]: {
    pl: "Zajawka nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Excerpt cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_WEBSITE_NOT_VALID]: {
    pl: "Strona internetowa nie jest prawid\u0142owa",
    en: "Website is not valid"
  },
  [ErrorCode.ERR_NOTES_NOT_VALID]: {
    pl: "Notatki nie s\u0105 prawid\u0142owe",
    en: "Notes are not valid"
  },
  [ErrorCode.ERR_INVALID_DATE_FORMAT]: {
    pl: "Nieprawid\u0142owy format daty",
    en: "Invalid date format"
  },
  [ErrorCode.ERR_INVALID_ORDER_ID]: {
    pl: "Nieprawid\u0142owy format ID zam\xF3wienia",
    en: "Invalid order ID format"
  },
  [ErrorCode.ERR_INVALID_DOCTOR_ID]: {
    pl: "Nieprawid\u0142owy format ID lekarza",
    en: "Invalid doctor ID format"
  },
  [ErrorCode.ERR_INVALID_TEMPLATE_KEY]: {
    pl: "Nieprawid\u0142owy identyfikator szablonu formularza",
    en: "Invalid travel form template key"
  },
  [ErrorCode.ERR_INVALID_TEMPLATE_VERSION]: {
    pl: "Nieprawid\u0142owa wersja szablonu formularza",
    en: "Invalid travel form template version"
  },
  [ErrorCode.ERR_CANNOT_CREATE_CONSULTATION_FOR_OTHER_USER]: {
    pl: "Nie mo\u017Cna utworzy\u0107 konsultacji dla innego u\u017Cytkownika",
    en: "Cannot create consultation for another user"
  },
  [ErrorCode.ERR_CONSULTATION_CREATION_FAILED]: {
    pl: "Tworzenie konsultacji nie powiod\u0142o si\u0119",
    en: "Consultation creation failed"
  },
  [ErrorCode.ERR_CONSULTATION_UPDATE_FAILED]: {
    pl: "Aktualizacja konsultacji nie powiod\u0142a si\u0119",
    en: "Consultation update failed"
  },
  [ErrorCode.ERR_CONSULTATION_NOT_FOUND]: {
    pl: "Konsultacja nie zosta\u0142a znaleziona",
    en: "Consultation not found"
  },
  [ErrorCode.ERR_CANNOT_UPDATE_CONSULTATION_FOR_OTHER_USER]: {
    pl: "Nie mo\u017Cna zaktualizowa\u0107 konsultacji dla innego u\u017Cytkownika",
    en: "Cannot update consultation for another user"
  },
  [ErrorCode.ERR_CONSULTATIONS_NOT_FOUND]: {
    pl: "Konsultacje nie zosta\u0142y znalezione",
    en: "Consultations not found"
  },
  [ErrorCode.ERR_CANNOT_DELETE_CONSULTATION]: {
    pl: "Nie mo\u017Cna usun\u0105\u0107 konsultacji",
    en: "Cannot delete consultation"
  },
  [ErrorCode.ERR_CONSULTATION_DELETION_FAILED]: {
    pl: "Usuni\u0119cie konsultacji nie powiod\u0142o si\u0119",
    en: "Consultation deletion failed"
  },
  [ErrorCode.ERR_INVALID_ORDER_STATUS]: {
    pl: "Nieprawid\u0142owy status zam\xF3wienia",
    en: "Invalid order status"
  },
  [ErrorCode.ERR_COUNTRY_NOT_ISO31661_ALPHA2]: {
    pl: "Kraj musi by\u0107 kodem ISO 3166-1 alpha-2",
    en: "Country must be an ISO 3166-1 alpha-2 code"
  },
  [ErrorCode.ERR_COUNTRY_NOT_UPPERCASE]: {
    pl: "Kraj musi by\u0107 wielkimi literami",
    en: "Country must be in uppercase"
  },
  [ErrorCode.ERR_COUNTRY_NOT_EMPTY]: {
    pl: "Kraj nie mo\u017Ce by\u0107 pusty",
    en: "Country cannot be empty"
  },
  [ErrorCode.ERR_COUNTRY_LENGTH_2]: {
    pl: "Kraj musi mie\u0107 2 znaki",
    en: "Country must be 2 characters long"
  },
  [ErrorCode.ERR_LANGUAGE_NOT_VALID]: {
    pl: "J\u0119zyk nie jest prawid\u0142owy",
    en: "Language is not valid"
  },
  [ErrorCode.ERR_LANGUAGE_NOT_LOWERCASE]: {
    pl: "J\u0119zyk musi by\u0107 w ma\u0142ych literach",
    en: "Language must be in lowercase"
  },
  [ErrorCode.ERR_LANGUAGE_NOT_EMPTY]: {
    pl: "J\u0119zyk nie mo\u017Ce by\u0107 pusty",
    en: "Language cannot be empty"
  },
  [ErrorCode.ERR_LANGUAGE_LENGTH_2]: {
    pl: "J\u0119zyk musi mie\u0107 2 znaki",
    en: "Language must be 2 characters long"
  },
  [ErrorCode.ERR_TIME_ZONE_NOT_STRING]: {
    pl: "Strefa czasowa musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Time zone must be a string"
  },
  [ErrorCode.ERR_TIME_ZONE_NOT_VALID]: {
    pl: "Strefa czasowa nie jest prawid\u0142owa",
    en: "Time zone is not valid"
  },
  [ErrorCode.ERR_TIME_ZONE_NOT_EMPTY]: {
    pl: "Strefa czasowa nie mo\u017Ce by\u0107 pusta",
    en: "Time zone cannot be empty"
  },
  [ErrorCode.ERR_INVALID_DATE_RANGE]: {
    pl: "Nieprawid\u0142owy zakres dat: podaj dok\u0142adnie 2 prawid\u0142owe przysz\u0142e daty, gdzie data ko\u0144cowa jest po dacie pocz\u0105tkowej",
    en: "Invalid date range: provide exactly 2 valid future dates where endDate is after startDate"
  },
  [ErrorCode.ERR_INVALID_STATUS]: {
    pl: "Nieprawid\u0142owy status",
    en: "Invalid status"
  },
  [ErrorCode.ERR_OFFER_GROUP_NOT_DELETABLE]: {
    pl: "Grupa ofert nie jest usuwalna",
    en: "Offer group is not deletable"
  },
  [ErrorCode.ERR_PAYMENT_NOT_FOUND]: {
    pl: "P\u0142atno\u015B\u0107 nie zosta\u0142a znaleziona",
    en: "Payment not found"
  },
  [ErrorCode.ERR_PAYMENT_STATUS_CHANGE_FAILED]: {
    pl: "Zmiana statusu p\u0142atno\u015Bci nie powiod\u0142a si\u0119",
    en: "Payment status change failed"
  },
  [ErrorCode.ERR_INVALID_PAYMENT_STATUS]: {
    pl: "Nieprawid\u0142owy status p\u0142atno\u015Bci",
    en: "Invalid payment status"
  },
  [ErrorCode.ERR_PAYMENT_NOT_UPDATED]: {
    pl: "P\u0142atno\u015B\u0107 nie zosta\u0142a zaktualizowana",
    en: "Payment not updated"
  },
  [ErrorCode.ERR_INVALID_PAYMENT_ID]: {
    pl: "Nieprawid\u0142owy format ID p\u0142atno\u015Bci",
    en: "Invalid payment ID format"
  },
  [ErrorCode.ERR_INVALID_PAYMENT_METHOD]: {
    pl: "Nieprawid\u0142owy format metody p\u0142atno\u015Bci",
    en: "Invalid payment method format"
  },
  [ErrorCode.ERR_INVALID_AMOUNT]: {
    pl: "Nieprawid\u0142owa kwota p\u0142atno\u015Bci",
    en: "Invalid payment amount"
  },
  [ErrorCode.ERR_INVALID_CURRENCY_CODE]: {
    pl: "Nieprawid\u0142owy format kodu waluty",
    en: "Invalid currency code format"
  },
  [ErrorCode.ERR_EXTERNAL_ID_MAX_LENGTH_255]: {
    pl: "ID zewn\u0119trzny nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "External ID cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_CREATE_PAYMENT_FAILED]: {
    pl: "Tworzenie p\u0142atno\u015Bci nie powiod\u0142o si\u0119",
    en: "Creating payment failed"
  },
  [ErrorCode.ERR_CANNOT_CREATE_PAYMENT_FOR_OTHER_USER]: {
    pl: "Nie mo\u017Cna utworzy\u0107 p\u0142atno\u015Bci dla zam\xF3wienia innego u\u017Cytkownika",
    en: "Cannot create payment for another user's order"
  },
  [ErrorCode.ERR_CANNOT_ACCESS_PAYMENT]: {
    pl: "Nie masz uprawnie\u0144 do dost\u0119pu do tej p\u0142atno\u015Bci",
    en: "You do not have permission to access this payment"
  },
  [ErrorCode.ERR_PAYMENT_INITIALIZATION_FAILED]: {
    pl: "Inicjalizacja p\u0142atno\u015Bci nie powiod\u0142a si\u0119",
    en: "Payment initialization failed"
  },
  [ErrorCode.ERR_WEBHOOK_HANDLING_FAILED]: {
    pl: "Obs\u0142uga webhooka p\u0142atno\u015Bci nie powiod\u0142a si\u0119",
    en: "Payment webhook handling failed"
  },
  [ErrorCode.ERR_PAYMENT_NOT_INITIALIZED]: {
    pl: "P\u0142atno\u015B\u0107 nie zosta\u0142a zainicjalizowana",
    en: "Payment has not been initialized"
  },
  [ErrorCode.ERR_PAYMENT_STATUS_CHECK_FAILED]: {
    pl: "Sprawdzenie statusu p\u0142atno\u015Bci nie powiod\u0142o si\u0119",
    en: "Payment status check failed"
  },
  [ErrorCode.ERR_PAYMENT_PROVIDER_NOT_AVAILABLE]: {
    pl: "Dostawca p\u0142atno\u015Bci dla wybranej metody nie jest dost\u0119pny",
    en: "Payment provider for the selected method is not available"
  },
  [ErrorCode.ERR_PAYMENT_STRIPE_NOT_CONFIGURED]: {
    pl: "P\u0142atno\u015Bci Stripe nie s\u0105 skonfigurowane na serwerze (brak klucza API)",
    en: "Stripe payments are not configured on the server (API secret key missing)"
  },
  [ErrorCode.ERR_INVALID_PAYMENT_PURPOSE]: {
    pl: "Nieprawid\u0142owy cel p\u0142atno\u015Bci",
    en: "Invalid payment purpose"
  },
  [ErrorCode.ERR_INVALID_CONSULTATION_ID]: {
    pl: "Nieprawid\u0142owy identyfikator konsultacji",
    en: "Invalid consultation ID"
  },
  [ErrorCode.ERR_INVALID_OFFER_ID]: {
    pl: "Nieprawid\u0142owy identyfikator oferty",
    en: "Invalid offer ID"
  },
  [ErrorCode.ERR_CONSULTATION_NOT_BELONG_TO_ORDER]: {
    pl: "Konsultacja nie nale\u017Cy do tego zam\xF3wienia",
    en: "Consultation does not belong to this order"
  },
  [ErrorCode.ERR_OFFER_NOT_BELONG_TO_ORDER]: {
    pl: "Oferta nie nale\u017Cy do tego zam\xF3wienia",
    en: "Offer does not belong to this order"
  },
  [ErrorCode.ERR_PAYMENT_PURPOSE_MISMATCH]: {
    pl: "Cel p\u0142atno\u015Bci nie pasuje do podanych danych",
    en: "Payment purpose does not match provided data"
  },
  [ErrorCode.ERR_CONSULTATION_ID_REQUIRED]: {
    pl: "Identyfikator konsultacji jest wymagany dla p\u0142atno\u015Bci za konsultacj\u0119",
    en: "Consultation ID is required for consultation payment"
  },
  [ErrorCode.ERR_OFFER_ID_REQUIRED]: {
    pl: "Identyfikator oferty jest wymagany dla p\u0142atno\u015Bci za ofert\u0119",
    en: "Offer ID is required for offer payment"
  },
  [ErrorCode.ERR_PAYMENT_AMOUNT_MISMATCH]: {
    pl: "Kwota p\u0142atno\u015Bci nie odpowiada cenie konsultacji lub oferty",
    en: "Payment amount does not match consultation or offer price"
  },
  [ErrorCode.ERR_PAYMENT_AMOUNT_EXCEEDS_REMAINING]: {
    pl: "Kwota p\u0142atno\u015Bci przekracza pozosta\u0142\u0105 do zap\u0142aty cz\u0119\u015B\u0107",
    en: "Payment amount exceeds remaining balance"
  },
  [ErrorCode.ERR_PAYMENT_AMOUNT_REQUIRED]: {
    pl: "Kwota p\u0142atno\u015Bci jest wymagana",
    en: "Payment amount is required"
  },
  [ErrorCode.ERR_PAYMENT_AMOUNT_NOT_POSITIVE]: {
    pl: "Kwota p\u0142atno\u015Bci musi by\u0107 wi\u0119ksza od zera",
    en: "Payment amount must be greater than zero"
  },
  [ErrorCode.ERR_PAYMENT_AMOUNT_EXCEEDS_ORDER_TOTAL]: {
    pl: "Suma p\u0142atno\u015Bci przekracza ca\u0142kowit\u0105 warto\u015B\u0107 zam\xF3wienia",
    en: "Total payments exceed order total amount"
  },
  [ErrorCode.ERR_PAYMENT_ALREADY_PAID]: {
    pl: "Ta konsultacja lub oferta zosta\u0142a ju\u017C op\u0142acona w ca\u0142o\u015Bci",
    en: "This consultation or offer is already fully paid"
  },
  [ErrorCode.ERR_PAYMENT_ALREADY_COMPLETED]: {
    pl: "P\u0142atno\u015B\u0107 zosta\u0142a ju\u017C zrealizowana i nie mo\u017Ce zosta\u0107 anulowana",
    en: "Payment has already been completed and cannot be cancelled"
  },
  [ErrorCode.ERR_REFUND_NOT_AVAILABLE]: {
    pl: "Zwrot dla tej p\u0142atno\u015Bci nie jest mo\u017Cliwy",
    en: "Refund is not available for this payment"
  },
  [ErrorCode.ERR_REFUND_AMOUNT_NOT_POSITIVE]: {
    pl: "Kwota zwrotu musi by\u0107 wi\u0119ksza od zera",
    en: "Refund amount must be greater than zero"
  },
  [ErrorCode.ERR_REFUND_AMOUNT_EXCEEDS_AVAILABLE]: {
    pl: "Kwota zwrotu przekracza dost\u0119pn\u0105 kwot\u0119 do zwrotu",
    en: "Refund amount exceeds available refundable amount"
  },
  [ErrorCode.ERR_REFUND_FAILED]: {
    pl: "Zwrot nie powi\xF3d\u0142 si\u0119. Spr\xF3buj ponownie lub wykonaj go r\u0119cznie.",
    en: "Refund failed. Please try again or process it manually."
  },
  [ErrorCode.ERR_DUPLICATE_PAYMENT_EXISTS]: {
    pl: "P\u0142atno\u015B\u0107 dla tej konsultacji lub oferty ju\u017C istnieje",
    en: "Payment for this consultation or offer already exists"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_LINES_REQUIRED]: {
    pl: "Checkout musi zawiera\u0107 co najmniej jedn\u0105 pozycj\u0119",
    en: "Checkout must contain at least one line item"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_NOT_FOUND]: {
    pl: "Nie znaleziono p\u0142atno\u015Bci zbiorczej (checkout)",
    en: "Order checkout not found"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_DUPLICATE_LINES]: {
    pl: "Aktywny rachunek z tym samym zestawem pozycji ju\u017C istnieje",
    en: "An active payment request with the same line items already exists"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_BILLABLE_IN_AWAITING_CHECKOUT]: {
    pl: "Co najmniej jedna wybrana pozycja jest ju\u017C w innym checkoucie oczekuj\u0105cym na p\u0142atno\u015B\u0107",
    en: "At least one selected line is already part of another checkout awaiting payment"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_NOT_PAYABLE]: {
    pl: "Ten checkout nie oczekuje na p\u0142atno\u015B\u0107",
    en: "This checkout is not awaiting payment"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_PATIENT_ENSURE_FORBIDDEN]: {
    pl: "Rachunek mo\u017Ce utworzy\u0107 wy\u0142\u0105cznie koordynator \u2014 poczekaj na przygotowany rachunek",
    en: "Only your coordinator can create the payment request \u2014 please wait for it to be prepared"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_OFFER_PAYMENT_INIT_FORBIDDEN]: {
    pl: "Nie mo\u017Cesz samodzielnie rozpocz\u0105\u0107 nowej pr\xF3by p\u0142atno\u015Bci za checkout \u2014 u\u017Cyj linku od koordynatora lub kontynuuj istniej\u0105c\u0105 p\u0142atno\u015B\u0107",
    en: "You cannot start a new checkout payment attempt yourself \u2014 use the link from your coordinator or continue an existing payment"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_NOT_CANCELLABLE]: {
    pl: "Tego checkoutu nie mo\u017Cna anulowa\u0107 (nie oczekuje na p\u0142atno\u015B\u0107 lub istnieje zako\u0144czona p\u0142atno\u015B\u0107)",
    en: "This checkout cannot be cancelled (not awaiting payment or a completed payment exists)"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_MANUAL_LINE_INVALID]: {
    pl: "Nieprawid\u0142owa pozycja niestandardowa lub rabat \u2014 podaj tytu\u0142 i dodatni\u0105 kwot\u0119",
    en: "Invalid custom line or discount \u2014 provide a title and a positive amount"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_NOT_RECORDABLE]: {
    pl: "Nie mo\u017Cna zarejestrowa\u0107 wp\u0142aty dla tego rachunku (nieprawid\u0142owy status lub rachunek ju\u017C rozliczony)",
    en: "Cannot record a transfer for this payment request (invalid status or already settled)"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_ADMIN_ONLY]: {
    pl: "Ta operacja jest dost\u0119pna wy\u0142\u0105cznie dla administrator\xF3w",
    en: "This operation is available to administrators only"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_TRANSFER_AMOUNT_INVALID]: {
    pl: "Kwota przelewu musi by\u0107 wi\u0119ksza od zera",
    en: "Transfer amount must be greater than zero"
  },
  [ErrorCode.ERR_ORDER_CHECKOUT_TRANSFER_AMOUNT_EXCEEDS_REMAINING]: {
    pl: "Kwota przelewu znacznie przekracza pozosta\u0142\u0105 nale\u017Cno\u015B\u0107 \u2014 sprawd\u017A kwot\u0119 i spr\xF3buj ponownie",
    en: "Transfer amount significantly exceeds the remaining balance \u2014 please verify and try again"
  },
  [ErrorCode.ERR_INVALID_REDIRECT_URL_DOMAIN]: {
    pl: "URL przekierowania musi by\u0107 z dozwolonej domeny",
    en: "Redirect URL must be from an allowed domain"
  },
  [ErrorCode.ERR_PAYMENT_REDIRECT_DOMAIN_NOT_CONFIGURED]: {
    pl: "Dopuszczalne domeny przekierowa\u0144 p\u0142atno\u015Bci nie s\u0105 skonfigurowane",
    en: "Allowed payment redirect domains are not configured"
  },
  [ErrorCode.ERR_WEBHOOK_EVENT_ID_REQUIRED]: {
    pl: "Tre\u015B\u0107 webhooka musi zawiera\u0107 prawid\u0142owy identyfikator zdarzenia (pole id)",
    en: "Webhook payload must include a valid event identifier (id field)"
  },
  [ErrorCode.ERR_WEBHOOK_SIGNATURE_REQUIRED]: {
    pl: "Weryfikacja sygnatury webhook jest wymagana",
    en: "Webhook signature verification is required"
  },
  [ErrorCode.ERR_WEBHOOK_IP_NOT_ALLOWED]: {
    pl: "IP adres nie jest dozwolony dla webhook\xF3w",
    en: "IP address is not allowed for webhooks"
  },
  [ErrorCode.ERR_PAYMENT_WEBHOOK_IP_WHITELIST_NOT_CONFIGURED]: {
    pl: "Lista dozwolonych adres\xF3w IP dla webhook\xF3w nie jest skonfigurowana",
    en: "Webhook IP whitelist is not configured"
  },
  [ErrorCode.ERR_INVALID_STATUS_TRANSITION]: {
    pl: "Nieprawid\u0142owe przej\u015Bcie statusu p\u0142atno\u015Bci",
    en: "Invalid payment status transition"
  },
  [ErrorCode.ERR_EXTERNAL_ID_ALREADY_EXISTS]: {
    pl: "Zewn\u0119trzny identyfikator p\u0142atno\u015Bci ju\u017C istnieje",
    en: "Payment external ID already exists"
  },
  [ErrorCode.ERR_OFFER_TITLE_NOT_STRING]: {
    pl: "Tytu\u0142 oferty musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Offer title must be a string"
  },
  [ErrorCode.ERR_OFFER_TITLE_MAX_LENGTH_255]: {
    pl: "Tytu\u0142 oferty nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Offer title cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_OFFER_TITLE_MIN_LENGTH_3]: {
    pl: "Tytu\u0142 oferty musi mie\u0107 co najmniej 3 znaki",
    en: "Offer title must be at least 3 characters long"
  },
  [ErrorCode.ERR_OFFER_PRICE_MAX_DECIMAL_PLACES]: {
    pl: "Cena oferty musi mie\u0107 maksymalnie 2 miejsca po przecinku",
    en: "Offer price must have a maximum of 2 decimal places"
  },
  [ErrorCode.ERR_OFFER_PRICE_MIN_VALUE]: {
    pl: "Cena oferty nie mo\u017Ce by\u0107 mniejsza ni\u017C 0",
    en: "Offer price cannot be less than 0"
  },
  [ErrorCode.ERR_OFFER_PRICE_MAX_VALUE]: {
    pl: "Cena oferty nie mo\u017Ce przekracza\u0107 9,999,999,999.99 PLN",
    en: "Offer price cannot exceed 9,999,999,999.99 PLN"
  },
  [ErrorCode.ERR_OFFER_NOT_FOUND]: {
    pl: "Oferta nie zosta\u0142a znaleziona",
    en: "Offer not found"
  },
  [ErrorCode.ERR_OFFER_CREATION_FAILED]: {
    pl: "Tworzenie oferty nie powiod\u0142o si\u0119",
    en: "Offer creation failed"
  },
  [ErrorCode.ERR_OFFER_UPDATE_FAILED]: {
    pl: "Aktualizacja oferty nie powiod\u0142a si\u0119",
    en: "Offer update failed"
  },
  [ErrorCode.ERR_OFFER_DELETION_FAILED]: {
    pl: "Usuni\u0119cie oferty nie powiod\u0142o si\u0119",
    en: "Offer deletion failed"
  },
  [ErrorCode.ERR_OFFER_NOT_DELETED]: {
    pl: "Oferta nie zosta\u0142a usuni\u0119ta",
    en: "Offer not deleted"
  },
  [ErrorCode.ERR_OFFER_GROUP_NOT_FOUND]: {
    pl: "Grupa ofert nie zosta\u0142a znaleziona",
    en: "Offer group not found"
  },
  [ErrorCode.ERR_OFFER_GROUP_TITLE_NOT_EDITABLE]: {
    pl: "Nazwy pakietu nie mo\u017Cna zmieni\u0107 po wys\u0142aniu oferty do pacjenta",
    en: "The package name cannot be changed after the offer has been sent to the patient"
  },
  [ErrorCode.ERR_OFFER_GROUP_CREATION_FAILED]: {
    pl: "Tworzenie grupy ofert nie powiod\u0142o si\u0119",
    en: "Offer group creation failed"
  },
  [ErrorCode.ERR_OFFER_GROUP_UPDATE_FAILED]: {
    pl: "Aktualizacja grupy ofert nie powiod\u0142a si\u0119",
    en: "Offer group update failed"
  },
  [ErrorCode.ERR_OFFER_GROUP_DELETION_FAILED]: {
    pl: "Usuni\u0119cie grupy ofert nie powiod\u0142o si\u0119",
    en: "Offer group deletion failed"
  },
  [ErrorCode.ERR_OFFER_GROUP_NOT_DELETED]: {
    pl: "Grupa ofert nie zosta\u0142a usuni\u0119ta",
    en: "Offer group not deleted"
  },
  [ErrorCode.ERR_USER_NOT_AUTHORIZED_TO_ACCESS_OFFER_GROUP]: {
    pl: "U\u017Cytkownik nie ma uprawnie\u0144 do dost\u0119pu do grupy ofert",
    en: "User is not authorized to access offer group"
  },
  [ErrorCode.ERR_USER_NOT_AUTHORIZED_TO_ACCESS_OFFER]: {
    pl: "U\u017Cytkownik nie ma uprawnie\u0144 do dost\u0119pu do oferty",
    en: "User is not authorized to access offer"
  },
  [ErrorCode.ERR_INVALID_RANGE_HEADER]: {
    pl: "Nieprawid\u0142owy nag\u0142\xF3wek zakresu",
    en: "Invalid range header"
  },
  [ErrorCode.ERR_INVALID_URL]: {
    pl: "Nieprawid\u0142owy format URL",
    en: "Invalid URL format"
  },
  [ErrorCode.ERR_SORT_ORDER_NOT_INTEGER]: {
    pl: "Sort order musi by\u0107 liczb\u0105 ca\u0142kowit\u0105",
    en: "Sort order must be an integer"
  },
  [ErrorCode.ERR_SORT_ORDER_MIN_0]: {
    pl: "Sort order musi by\u0107 wi\u0119kszy ni\u017C 0",
    en: "Sort order must be greater than 0"
  },
  [ErrorCode.ERR_SORT_NOT_VALID]: {
    pl: "Nieprawid\u0142owa warto\u015B\u0107 sortowania",
    en: "Invalid sort value"
  },
  [ErrorCode.ERR_CONTENT_TITLE_NOT_STRING]: {
    pl: "Tytu\u0142 tre\u015Bci musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Content title must be a string"
  },
  [ErrorCode.ERR_CONTENT_TITLE_MAX_LENGTH_255]: {
    pl: "Tytu\u0142 tre\u015Bci nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Content title cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_CONTENT_TITLE_MIN_LENGTH_3]: {
    pl: "Tytu\u0142 tre\u015Bci musi mie\u0107 co najmniej 3 znaki",
    en: "Content title must be at least 3 characters long"
  },
  [ErrorCode.ERR_CONTENT_NAME_NOT_STRING]: {
    pl: "Nazwa tre\u015Bci musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Content name must be a string"
  },
  [ErrorCode.ERR_CONTENT_NAME_MAX_LENGTH_255]: {
    pl: "Nazwa tre\u015Bci nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Content name cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_CONTENT_NAME_MIN_LENGTH_3]: {
    pl: "Nazwa tre\u015Bci musi mie\u0107 co najmniej 3 znaki",
    en: "Content name must be at least 3 characters long"
  },
  [ErrorCode.ERR_CONTENT_DESCRIPTION_NOT_STRING]: {
    pl: "Opis tre\u015Bci musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Content description must be a string"
  },
  [ErrorCode.ERR_CONTENT_DESCRIPTION_MIN_LENGTH_10]: {
    pl: "Opis tre\u015Bci musi mie\u0107 co najmniej 10 znak\xF3w",
    en: "Content description must be at least 10 characters long"
  },
  [ErrorCode.ERR_CONTENT_DESCRIPTION_MAX_LENGTH_2000]: {
    pl: "Opis tre\u015Bci nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 2000 znak\xF3w",
    en: "Content description cannot be longer than 2000 characters"
  },
  [ErrorCode.ERR_CONTENT_DESCRIPTION_MAX_LENGTH_3000]: {
    pl: "Opis tre\u015Bci nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 3000 znak\xF3w",
    en: "Content description cannot be longer than 3000 characters"
  },
  [ErrorCode.ERR_CONTENT_LIST_NOT_ARRAY]: {
    pl: "Lista tre\u015Bci musi by\u0107 tablic\u0105",
    en: "Content list must be an array"
  },
  [ErrorCode.ERR_DOCTOR_NAME_NOT_STRING]: {
    pl: "Imi\u0119 i nazwisko lekarza musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Doctor name and last name must be a string"
  },
  [ErrorCode.ERR_DOCTOR_NAME_MIN_LENGTH_3]: {
    pl: "Imi\u0119 i nazwisko lekarza musi mie\u0107 co najmniej 3 znaki",
    en: "Doctor name and last name must be at least 3 characters long"
  },
  [ErrorCode.ERR_DOCTOR_NAME_MAX_LENGTH_255]: {
    pl: "Imi\u0119 i nazwisko lekarza nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Doctor name and last name cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_DOCTOR_DEGREE_NOT_STRING]: {
    pl: "Stopie\u0144 lekarza musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Doctor degree must be a string"
  },
  [ErrorCode.ERR_DOCTOR_DEGREE_MAX_LENGTH_255]: {
    pl: "Stopie\u0144 lekarza nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Doctor degree cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_DOCTOR_SPECIALIZATION_NOT_STRING]: {
    pl: "Specjalizacja lekarza musi by\u0107 ci\u0105giem znak\xF3w",
    en: "Doctor specialization must be a string"
  },
  [ErrorCode.ERR_DOCTOR_SPECIALIZATION_MAX_LENGTH_255]: {
    pl: "Specjalizacja lekarza nie mo\u017Ce mie\u0107 wi\u0119cej ni\u017C 255 znak\xF3w",
    en: "Doctor specialization cannot be longer than 255 characters"
  },
  [ErrorCode.ERR_CLIENT_ALREADY_ASSIGNED]: {
    pl: "Pacjent jest ju\u017C przypisany do innego agenta",
    en: "Patient is already assigned to another agent"
  },
  [ErrorCode.ERR_CLIENT_NOT_PATIENT]: {
    pl: "U\u017Cytkownik nie jest pacjentem",
    en: "User is not a patient"
  },
  [ErrorCode.ERR_OFFER_GENERATED_DOCUMENT_NOT_FOUND]: {
    pl: "Wygenerowany dokument oferty nie zosta\u0142 znaleziony",
    en: "Offer generated document not found"
  },
  [ErrorCode.ERR_OFFER_GENERATED_DOCUMENT_CREATION_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 utworzy\u0107 rekordu wygenerowanego dokumentu",
    en: "Failed to create offer generated document record"
  },
  [ErrorCode.ERR_OFFER_GENERATED_DOCUMENT_UPDATE_FAILED]: {
    pl: "Nie uda\u0142o si\u0119 zaktualizowa\u0107 rekordu wygenerowanego dokumentu",
    en: "Failed to update offer generated document record"
  },
  [ErrorCode.ERR_OFFER_DOCUMENT_GENERATION_FAILED]: {
    pl: "Generowanie dokumentu oferty nie powiod\u0142o si\u0119",
    en: "Offer document generation failed"
  },
  [ErrorCode.ERR_OFFER_GENERATED_DOCUMENTS_NOT_READY]: {
    pl: "Dokumenty oferty s\u0105 jeszcze w trakcie generowania \u2014 poczekaj, a\u017C zostan\u0105 przygotowane, a nast\u0119pnie spr\xF3buj ponownie",
    en: "Offer documents are still being generated \u2014 please wait until they are ready and try again"
  },
  [ErrorCode.ERR_OFFER_GENERATED_DOCUMENT_FAILED]: {
    pl: "Nie mo\u017Cna dokona\u0107 p\u0142atno\u015Bci \u2014 generowanie jednego lub wi\u0119cej dokument\xF3w oferty zako\u0144czy\u0142o si\u0119 niepowodzeniem. Skontaktuj si\u0119 z obs\u0142ug\u0105.",
    en: "Payment is unavailable \u2014 one or more offer documents failed to generate. Please contact support."
  },
  [ErrorCode.ERR_OFFER_DOCUMENTS_CONSENT_REQUIRED]: {
    pl: "Aby dokona\u0107 p\u0142atno\u015Bci, musisz wyrazi\u0107 zgod\u0119 na wszystkie dokumenty powi\u0105zane z ofert\u0105",
    en: "You must consent to all offer documents before proceeding with the payment"
  },
  [ErrorCode.ERR_AGENT_RESEND_SET_PASSWORD_NOT_APPLICABLE]: {
    pl: "Ponowne wys\u0142anie linku jest dost\u0119pne tylko dla pacjent\xF3w z onboardingu linkowego, kt\xF3rzy nie zweryfikowali jeszcze konta",
    en: "Resending the set-password link is only available for link-onboarding patients who have not completed verification yet"
  },
  [ErrorCode.ERR_AGENT_RESEND_SET_PASSWORD_TOO_SOON]: {
    pl: "Link do ustawienia has\u0142a by\u0142 niedawno wys\u0142any. Spr\xF3buj ponownie p\xF3\u017Aniej",
    en: "A set-password link was sent recently. Please try again later"
  }
};
export {
  ErrorCode,
  ErrorCodes,
  messages
};
